import hostConfig from './host.config'

const HOSTOLD = hostConfig.config.hostOld
const HOSTOLDWX = hostConfig.config.hostOld2
const HOST = hostConfig.config.hostApi
const HOSTCOMMON = hostConfig.config.hostCommon
const HOSTAPP = hostConfig.config.hostApp
const HOSTRESOURCEPATH = hostConfig.config.hostResourcePath
const NEWHOST = hostConfig.config.newHost
const CRMHOST = hostConfig.config.crmHost
/**
 * 获取大搜新就接口配置
 */
const GET_GRAY = HOST + 'management/getGray'
/**
 * 定制购物车
 */
const COUNT_POSTAGE = HOST + 'mall-api/car/countPostage.json'
const CREATE_ORDER = HOST + 'mall-api/car/createOrder.json'
const GET_CART_LIST = HOST + 'mall-api/car/get.json'
const GET_SHOPPING_CART_COUPON = HOST + 'mall-api/car/getShoppingCartCoupon.json'

/**
 * 问答一键求助
 */
const REWARD_AMOUNT_PAGE = HOST + 'common-api/rewardAmountPage'
const TOP_CARD_STYLE = HOST + 'common-api/topCardStyle'
/**
 * 问答1.4
 */
const GET_QUICK_QA_INFOS = HOST + 'common-api/v1.4/qa/get_quick_qa_page'
const IS_PICK_UPER = HOST + 'common-api/v1.4/qa/is_pick_uper'
/**
 * 新问答1.3
 */
// 获取亲密度指数详情
// const GET_QUICK_QA_INFOS = HOST + 'common-api/v1.3/qa/list_qa'
const GET_QA_CONFIG = HOST + 'common-api/v1.3/qa/get_qa_config'
const LIST_SYMPTOM = HOST + 'common-api/v1.3/qa/list_symptom'
const EDIT_QUESTION = HOST + 'common-api/qaQuestion/editQuestion.json'
const UPDATE_QUESTION = HOST + 'common-api/v1.3/qa/update_question'
const LIST_DIALOG_INFO = HOST + 'common-api/v1.3/qa/list_dialog_info'
const LIST_MY_ANSWER = HOST + 'common-api/v1.3/qa/list_my_answer'
const QUERY_DATA_LIST = HOST + 'databi-api/report/list.json'
/**
 * 客户亲密度
 */
// 获取亲密度指数详情
const POST_CUSTOM_INTIMACY_DETAIL = HOST + 'common-api/intimacyInfo/detail'
// 放弃亲密度额度
const POST_ABANDON_INTIMACY_PRICE = HOST + 'common-api/intimacyInfo/giveUpQuota'
// 我的亲密客户列表
const POST_MY_INTIMACY_CUSTOMER_LIST = CRMHOST + 'crmApi/intimacyCustomer/list'
// 申请老友价
const POST_APPLY_FRIEND_PRICE = CRMHOST + 'crmApi/intimacyCustomer/applyFriendPrice'
// 申请插队
const POST_APPLY_JUMP_QUEUE = CRMHOST + 'crmApi/intimacyCustomer/applyJumpQueue'
// 客户亲密度审核等级列表
const POST_INTIMACY_VERIFY_LIST = CRMHOST + 'crmApi/intimacyVerify/list'
// 客户亲密度审核
const POST_INTIMACY_VERIFY = CRMHOST + 'crmApi/intimacyVerify/verify'

/**
 * 已复工维修站
 */
// 获取已复工维修站列表
const POST_ACTIVITY_SERVING_STATION_LIST = HOSTOLD + 'activity-api/servingStation/list.json'

// 根据当前坐标转换成具体位置
const POST_GET_ADDRESS_BY_LATLNG = HOSTOLD + 'common-api/addressByLatLng.json'

/**
 * 万物皆可埋点
 */
// 通过no获取链接
const POST_RECORD_POINT_GET_DETAIL = HOST + 'common-api/buriedPoint/detail.json'

// 增加埋点信息
const POST_RECORD_POINT_ADD_POINT = HOST + 'common-api/buriedPoint/add.json'

/**
 * 数据图书馆
 */
// 获取导航层级分类列表
const POST_DATA_LIB_GET_DIRECTORY_LIST = HOST + 'search-api/unitsSelector/getDirectoryList.json'

// 获取第一层US列表
const POST_DATA_LIB_GET_FIRST_UNITS_SELECTOR = HOST + 'search-api/unitsSelector/getFirstUnitsSelectorList.json'

// 获取子级US列表
const POST_DATA_LIB_GET_SUBLEVEL_UNITS_SELECTOR = HOST + 'search-api/unitsSelector/getSubLevelUnitsSelectorList.json'

// 获取资料列表
const POST_DATA_LIB_GET_RESULT_DATA_LIST = HOST + 'search-api/unitsSelector/getDataList.json'

// 数据流/故障码/后处理获取资料列表
const POST_DATA_LIB_GET_TREE_SHARE_LIST = HOST + 'search-api/unitsSelector/getTreeShareList.json'

// 获取US和资料列表
const POST_DATA_LIB_GET_US_OR_DATA_LIST = HOST + 'search-api/unitsSelector/getUnitsSelectorAndDataList.json'

/**
 * tab页 '我的' 相关接口
 */
// 获取会员中心社区信息
const POST_MEMBER_COMMUNITY_INFO = HOST + 'community/getMemberCenterCommunity.json'

// 获取用户信息
// const POST_MEMBER_GET_USER_INFO = HOST + 'user-api/getUserInfo.json'
const POST_MEMBER_GET_USER_INFO = HOST + 'user-api/info.json'

// 获取用户资产
// const POST_MEMBER_GET_USER_ASSETS = HOST + 'user-api/getUserAssets.json'
const POST_MEMBER_GET_USER_ASSETS = HOST + 'user-api/getUserAssets.json'

/**
 * 客户中心
 */
// 获取修车师傅列表
const POST_MEMBERSHIP_GET_REPAIR_LIST = HOST + 'common-api/expertUser/getExpertUserList.json'

// 获取礼品券
const POST_MEMBERSHIP_GET_TICKET_LIST = HOST + 'user-api/getNewGiftList.json'

// 获取星豆任务列表
const POST_MEMBERSHIP_GET_TASK_LIST = HOST + 'communityTask/getNewTaskList.json'

// 获取课堂回放列表
const POST_MEMBERSHIP_GET_PLAYBACK_LIST = HOST + 'broadcast/getPlayBackList.json'

/**
 * 会员邀请
 */
const POST_MEMBERSHIP_GET_RECOMMEND_INFO = HOST + 'wxUserRecommend/getUserRecommend.json'

/**
 * 会员礼品
 */
// 获取会员礼品集合
const POST_MEMBERSHIP_GIFTS_GET_LIST = HOST + 'user-api/memberGift/getGiftList.json'

// 获取会员礼品统计信息
const POST_MEMBERSHIP_GIFTS_GET_INFO = HOST + 'user-api/memberGift/getUserMemberGiftCoupon.json'

// 获取礼品详情
const POST_MEMBERSHIP_GIFT_GET_DETAIL = HOST + 'user-api/memberGift/getGiftDetails.json'

// 加入礼品篮
const POST_MEMBERSHIP_GIFT_ADD_TROLLEY = HOST + 'user-api/memberGift/addGiftCar.json'

// 获取已领礼品列表
const POST_MEMBERSHIP_GIFT_RECEIVE_LIST = HOST + 'user-api/memberGift/getReceiveGiftList.json'

// 获取用户礼品篮
const POST_MEMBERSHIP_GIFT_TROLLEY_DETAIL = HOST + 'user-api/memberGift/getUserGiftCar.json'

// 从礼品篮中移除礼品
const POST_MEMBERSHIP_GIFT_REMOVE_TROLLEY = HOST + 'user-api/memberGift/removeGiftCar.json'

// 会员礼品提交订单
const POST_MEMBERSHIP_GIFT_SUBMIT_ORDER = HOST + 'mall-api/order/quickGiftPay.json'

// 获取收获地址列表
const POST_ADDRESS_GET_LIST = HOST + 'user-api/app/address/list'

// 删除指定地址列表
const POST_ADDRESS_DEL_ITEM = HOST + 'user-api/app/address/remove'

// 获取指定地址详情
const POST_ADDRESS_GET_ITEM_DETAIL = HOST + 'user-api/app/address/detail'

// 新增或修改收获地址
const POST_ADDRESS_SAVE_ITEM_DETAIL = HOST + 'user-api/app/address/save'

// 设置用户默认地址
const POST_ADDRESS_SET_DEFAULT = HOST + 'user-api/memberGift/setDefaultAddress.json'

// 获取赠品订单审核详情
const POST_GETGIFT_ORDER_DETAIL = HOST + 'mall-api/giftOrder/getGiftOrderApplyById.json'

// 审核赠品订单
const POST_AUDITGIFTORDER = HOST + 'mall-api/giftOrder/auditGiftOrder.json'

/**
 * 抽奖大转盘 活动
 */
// 获取抽奖奖品及用户基本信息
const POST_ACTIVITY_TURNPLATE_PRICE_LIST = HOST + 'lotteryDraw/select4User'

// 获取用户中奖记录
const POST_ACTIVITY_TURNPLATE_PRICE_RECORD_LIST = HOST + 'lotteryDraw/allPrizes'

// 获取当前用户的中奖记录
const POST_ACTIVITY_TURNPLATE_USER_ALL_PRICE_LIST = HOST + 'lotteryDraw/myPrizes'

// 用户抽奖结果返回
const POST_ACTIVITY_TURNPLATE_USER_DRAW_PRICE = HOST + 'lotteryDraw/luckyDog'

/** 直播专用抽奖接口 */
// 获取抽奖奖品及用户基本信息
const POST_ACTIVITY_TURNPLATE_PRICE_LIST_LIVING = HOST + 'act/lotteryDraw/getLotteryDraw'

// 获取用户中奖记录
const POST_ACTIVITY_TURNPLATE_PRICE_RECORD_LIST_LIVING = HOST + 'act/lotteryDraw/allPrizes'

// 用户抽奖结果返回
const POST_ACTIVITY_TURNPLATE_USER_DRAW_PRICE_LIVING = HOST + 'act/lotteryDraw/luckyDog'

/**
 * 春节活动 测测您明年能赚多少钱
 */
// 提交答案 获取海报信息
const POST_ACTIVITY_HOW_MUCH_SUBMMIT_ANSWER = HOST + 'springPoster/addSpringPoster.json'

// 拉取分享人海报信息
const POST_ACTIVITY_HOW_MUCH_GET_POSTER_INFO = HOST + 'springPoster/getSpringPoster.json'

// 客户列表
const POST_CUSTOMER = HOST + 'miniUser/getUserList.json'

// 发动态
const POST_DYNAMIC = HOST + 'serviceStationDynamic/addServiceStationDynamic.json'

// 获取店铺信息
const POST_GETSHOPINFO = HOST + 'serviceStation/getServiceStation.json'

// 记账统计
const POST_BOOKKEEPING = HOST + 'databi-api/report/data/list.json'

// 【小轨将运营】文章未读接口
const POST_GETUNREAD = HOST + 'dataReportDocumentLog/getIsUnRead.json'

// 埋点
const POST_COLLECT = NEWHOST + 'common-api/log/add.json'

// 埋点
const POST_COLLECT_NEW = NEWHOST + 'search-api/maidian/maidian'

// 日志记录
const POST_SYS_LOG = NEWHOST + 'common-api/log/add.json'

const POST_ADVERT_GET_SIGN_LIST = HOST + 'common-api/advertPosition/getSignList.json'

const POST_ADVERT_POSITION = HOST + 'common-api/advertising/mark.json'

const POST_ADVERT_POSITION_NEW = HOST + 'common-api/advertPosition/signList.json'

// 校验session
const POST_WXAUTH_CHECK_SESSION = NEWHOST + 'user-api/common/login-ck.json'
// mapss 校验session是否登录
const POST_WXAUTH_CHECK_SESSION_MPASS = NEWHOST + 'common/login-ck.json'

// 获取APPID
const POST_WXAUTH_GET_APPID = NEWHOST + 'common-api/common/getkaxiuyunAppId.json'
// 获取无忧伙伴企业微信appid
const GET_WX_WORK_APPID = NEWHOST + 'common-api/common/getkaxiuyunQyAppId.json'
// 获取卡修宝典企业微信授权appid
const GET_WX_WORK_GGZJ_APPID = NEWHOST + 'common-api/common/getkaxiuyunGGQyAppId.json'

// 获取验证码
const POST_WXAUTH_VERIFY_CODE = HOST + 'authImage'

// 获取手机短信验证码
const POST_WXAUTH_PHONE_NOTE = HOST + 'common-api/member/sendMsg.json'

// 获取用户状态
const POST_USER_STATUS = HOST + 'user-api/getUserStatus.json'

// 支付请求
const POST_WXAUTH_PAY = HOST + 'wx/getPayJsParameter.json'

// 对比验证码
const POST_WXAUTH_CHECK_VERITY_CODE = HOST + 'ajaxCheckVerifyCode.json'

// 获取图片
const POST_WXAUTH_SLY_YOU = HOST + 'getDeskey.json'

// 检查是否需要验证码
const POST_WXAUTH_USER_LOG = HOST + 'common-api/ajaxUserLog.json'

// 添加收藏
const POST_COLLECTION_SAVE = HOST + 'user-api/fav/saveUserFavorite.json'

// 取消收藏
const POST_COLLECTION_CANCEL = HOST + 'user-api/fav/cancelUserFavorite.json'

// 查询测试数据
const POST_SOSO_TEST_DATA = HOST + 'testData/query.json'
const POST_SOSO_TEST_DATA_NEW = HOST + 'testData/queryList.json'
// 测试数据详情opensearch版
const POST_SOSO_TEST_DATA_DETAIL_OPEN_SEARCH = HOST + 'testData/detail.json'
// 查询测试数据列表数据opensearch
const POST_SOSO_TEST_DATA_OPEN_SEARCH = HOST + 'testData/search.json'

// 电路资料获取目录
const POST_SOSO_CIRCUIT_DATA_GETCATALOGUELIST = HOST + 'material/getCatalogueList.json'

// 电路资料获取文章
const POST_SOSO_CIRCUIT_DATA_GETMATERIALLIST = HOST + 'material/getMaterialList.json'

// 电路资料发送邮件
const POST_SOSO_CIRCUIT_DATA_SENDEMAIL = HOST + 'material/sendEmail.json'
// 电路资料保存邮箱
const POST_SOSO_CIRCUIT_DATA_REMEMBER_EMAIL = HOST + 'user-api/bindEmail.json'

// 垫片调整
const POST_SOSO_GASKET = HOST + 'gasketAdjust/query.json'

// 校验是否需要支付年费会员
const POST_MEMBER_SCOPE = HOST + 'training/verifyNeedPayYearFee.json'

// 诊断能手远程支持获取用户状态
const POST_REMOTE_SUPPORT_STATUS = HOST + 'app/decoderRemoteSupport.json'
// 诊断能手远程支持申请成功
const POST_REMOTE_SUPPORT_SUCCESS = HOST + 'app/decoderRemoteSupportSuccess.json'

/**
 * 故障代码
 */
// 故障码分页查询
const POST_FALT_CODE_LIST = HOST + 'faltCode/searchPage.json'

// 故障码详情页
const POST_FALT_CODE_DETAIL = HOST + 'faltCode/getDetail.json'

// 故障码标签
const POST_FALT_CODE_GETLABEL = HOST + 'faltCode/getLabel.json'

// 故障码提交
const POST_FALT_CODE_USERFEEDBACK = HOST + 'faltCode/userFeedBack.json'

// 故障码高级搜索
const POST_FALT_CODE_ADVANCEDSEARCH = HOST + 'faltCode/seniorSearchPage.json'

// 获取故障码排查步骤富文本内容
const POST_FALT_CODE_GETCHECKCONTENT = HOST + 'faltCode/getCheckContent.json'
const POST_FALT_CODE_GETCONTENT = HOST + 'faltCode/getTermContent.json'

/**
 * 资料查询
 */
const POST_FALT_CODE_SOSO = HOST + 'soso/searchPage.json'

// 故障码图文
const POST_GET_IMGTEXT = HOSTOLDWX + 'api/faltCode/kaxiuyunForumDetail.json'

/**
 * 系统部件
 */
// 部件信息查询
const POST_PARTS_INFO_GET = HOST + 'partsInfo/queryDetail.json'

const POST_PARTS_INFO_GET_NEW = HOST + 'partsInfo/queryList.json'
// 部件信息列表openserch版
const POST_PARTS_INFO_OPEN_SEARCH = HOST + 'partsInfo/query.json'
// 部件信息详情openserch版
const POST_PARTS_INFO_DETAIL_OPEN_SEARCH = HOST + 'partsInfo/detail.json'

// OHK查询
const POST_PARTS_OHK_INFO = HOST + 'partsInfo/getDetail.json'

// 获取发动机厂商
const POST_PARTS_INFO_ENGINE = HOST + 'partsInfo/getEngineCompany.json'

// 获取发动机型号
const POST_PARTS_INFO_ENGINENO = HOST + 'partsInfo/getEngineNo.json'

// 根据发动机型号 获取结果
const POST_PARTS_INFO_ENGINE_RESULT = HOST + 'partsInfo/getEngineResult.json'

/**
 * 经销商管理平台
 */
const POST_DEALERMANAGE_GET_DEALERINFO = HOST + 'distributor/getDetails.json'

const POST_DEALERMANAGE_GET_REBATEINFO = HOST + 'distributor/getCashBack.json'

const POST_DEALERMANAGE_REBATE_PUTFORWARD = HOST + 'distributor/userPutForward.json'

const POST_DEALERMANAGE_GET_MDSELIST = HOST + 'distributor/getMdseList.json'

const POST_DEALERMANAGE_SUBMIT_ORDER = HOST + 'distributor/submitOrder.json'

/**
 * 在线课堂
 */
const POST_COURSE_GET_LIST = HOST + '/video-api/course/own-list'

const POST_COURSE_GET_DETAIL = HOST + 'video-api/getCourseDetails.json'

const POST_COURSE_GET_URL = HOST + 'video-api/getCourseHourFileUrl.json'

const POST_COURSE_GET_COURSE_GROUP_STATUS = HOST + 'video-api/getCourseGroupStatus.json'

const POST_GET_COURSE_COMMENT = HOST + 'video-api/getCommentBycourseId.json'

const POST_ADD_COURSE_COMMENT = HOST + 'video-api/addCourseComment.json'

const POST_COURSE_ORDER_PAY = HOST + 'mall-api/order/quickCoursePay.json'

const POST_ORDER_SUBMIT = HOST + 'user-api/app/order/submit'

const POST_ORDER_PAY = HOST + 'user-api/app/order/pay'

const POST_ADD_COURSE_LOG = HOST + 'video-api/addCourseHourLog.json'

// 班课-推广页面-支付接口
const POST_COURSE_SPREAD_PURCHASE = HOST + 'mall-api/order/classCourseQuickPay.json'

// 班课-推广页面-课程类型列表
const POST_COURSE_SPREAD_CLASSIFY_LIST = HOST + 'classvideo-api/getClassifyList.json'

// 班课-推广页面-班课列表
const POST_COURSE_SPREAD_CLASS_COURSE_LIST = HOST + 'classvideo-api/getCourseList.json'

//  系列课-获取课程课时链接
const POST_GET_SERIES_COURSE_URL = HOST + 'video-api/getCourseHourFileUrlNew.json'

//  单课-系列课-班课 新增课时观看记录
const POST_ADD_COURSE_RECORD_NEW = HOST + 'video-api/addCourseHourLogNew.json'

// 单课-系列课-班课 新增课时观看记录(新)
const POST_ADD_HOUR_RECORD_NEW = HOST + 'video-api/video-learn/log'

// 课堂首页-热门课程
const POST_COURSE_HOT_COURSE_LIST = HOST + 'video-api/video/recommend.json'

// 课堂首页-直播回放tab直播、预约列表
const POST_COURSE_GET_BROADCASE_LIST = HOST + 'video-api/live/list.json'
// 课堂首页人推荐tab直播列表
const POST_COURSE_LIVE_BROADCASE_LIST = HOST + 'benbenOnlinevideo-api/liveBroadCastList.json'

// 课堂首页-分类列表
const POST_COURSE_CLASSIFY_LIST = HOST + 'video-api/video-classify/list'

// 课堂-课堂畅享卡页面
const POST_COURSE_ENJOY_COURSE_LIST = HOST + 'benbenOnlinevideo-api/getEnjoyCourseList.json'

// 课堂-学习记录
const POST_COURSE_STUDY_RECORD_LIST = HOST + 'video-api/video-learn/list.json'

// 课堂-课程搜索
const POST_COURSE_SEARCH_LIST = HOST + 'video-api/video/search'

// 课堂-课程种类详情页
const POST_COURSE_LIST_BY_CLASSIFY = HOST + 'video-api/classify-video/list'

// 课堂首页-直播列表信息
const POST_GET_BROADCAST_LIST = HOST + 'broadcast/getBroadcastList.json'

// 直播回放-查看更多-获取直播回放列表
const POST_GET_ENDED_BROADCAST_LIST = HOST + 'broadcast/getEndedBroadcastList.json'

// 直播回放-搜索回放视频
const POST_SEARCH_BROADCAST = HOST + 'broadcast/searchBroadcast.json'

// 直播回放-获取听课券基本信息
const POST_GET_TICKET_BASIC_VALUE = HOST + 'video-api/ticket/info.json'

// 直播回放-卡券支付
const POST_PAY_TICKET = HOST + 'broadcast/payTicketJsonNew.json'

// 直播回放-获取领券详情
const POST_GET_TICKET_DETAIL = HOST + 'video-api/ticket/detail.json'

// 直播回放-课堂支付接口
const POST_BROADCAST_PAY = HOST + 'broadcast/pay.json'

// 直播回放-分享领券
const POST_BROADCAST_GET_TICKET = HOST + 'broadcast/getTicket.json'

// 班课-获取班课课程详情
const POST_CLASS_COURSE_GET_COURSE_DETAIL = HOST + 'classvideo-api/getClassCourseDetails.json'

// 班课-获取班课具体课时的播放url
const POST_CLASS_COURSE_GET_COURSE_URL = HOST + 'classvideo-api/getClassCourseHourUrl.json'

// 班课-新增班课课时观看记录
const POST_CLASS_COURSE_ADD_HOUR_LOG = HOST + 'classvideo-api/addClassCourseHourLog.json'

// 课堂-单课获取防盗链视频URL
const POST_COURSE_GET_SECRET_URL = HOST + 'video-api/getCourseHourFileUrlNew.json'

// 课堂直播-获取直播基本信息
const POST_COURSE_GET_LIVE_INFO = HOST + 'broadcast/courseLiving.json'

// 课堂直播-课堂直播回放
const POST_COURSE_GET_LIVE_PLAYBACK = HOST + 'broadcast/playback.json'

// 课堂直播-犇犇课堂拆红包
const POST_COURSE_OPEN_REDPACKAGE = HOST + 'broadcast/openHb.json'

// 课堂直播-犇犇课堂留言
const POST_COURSE_SEND_MESSAGE = HOST + 'broadcast/viwerMessage.json'

// 课堂直播-犇犇课堂留言(新)
const POST_COURSE_SEND_MESSAGE_NEW = HOST + 'broadcast/viwerMessageNewest.json'

// 课堂直播-犇犇课堂打赏礼物列表
const POST_COURSE_GET_GIFT_LIST = HOST + 'broadcast/getRewardList.json'

// 课堂直播-犇犇课堂打赏
const POST_COURSE_GIVE_REWARD = HOST + 'mall-api/order/rewardsPay.json'

// 课堂直播-犇犇课堂点赞
const POST_COURSE_LIKE_COURSE = HOST + 'broadcast/likeCourse.json'

// 课堂直播-获取支付信息
const POST_COURSE_LIVE_PURCHASE = HOST + 'broadcoastActivity/wxPay.json'

// 课堂直播-获取邀请列表
const POST_COURSE_LIVE_INVITATION_LIST = HOST + 'broadcast/getInvitationList.json'

// 新课堂直播-获取福利列表
const POST_COURSE_LIVE_BENE_LIST = HOST + 'broadcast/benefits/listBenefits.json'

// 新课堂直播-查询福利详情
const POST_COURSE_LIVE_BENE_DETAIL = HOST + 'broadcast/benefits/detailBenefits.json'

// 新课堂直播-获取直播课件列表
const POST_COURSE_LIVE_WARE_LIST = HOST + 'broadcast/ware/listWare.json'

// 获取主持人历史发言记录
const POST_COURSE_LIVE_PRESENT_LIST = HOST + 'broadcast/ware/listPresenters.json'

// 新课堂直播尾款相关接口
const BALANCE = {
  // 获取尾款列表
  LIST_BENEFITS: HOST + 'broadcast/order/listBenefits.json',
  // 获取尾款详情
  DETAIL_BENEFIT_ORDER: HOST + 'broadcast/order/detailBenefitOrder.json',
  // 修改订单（尾款）的收货地址信息
  EDIT_ORDER_ADDRESS: HOST + 'broadcast/order/editOrderAddress.json',
  // 获取是否有手机号
  HAS_PHONE: HOST + 'user-api/getMemberPhone.json',
  // 支付福利订单尾款
  PAY_BENEFITS: HOST + 'broadcast/order/payBenefits.json'
}

// 课程4.0相关
const COURSE4 = {
  // 获取课程详情
  DETAIL_COURSE: HOST + 'video-api/video/detail',
  // 获取课程目录
  COURSE_HOUR_LIST: HOST + 'video-api/listCourseHour',
  // 获取课件列表
  COURSE_WARE_LIST: HOST + 'video-api/listCourseWare.json',
  // 获取课程提问列表
  COURSE_QA_LIST: HOST + 'video-api/pageCourseQa.json',
  // 新增课程提问
  ADD_COURSE_QA: HOST + 'video-api/addCourseQa.json',
  // 新增课程心得
  ADD_COURSE_EXP: HOST + 'video-api/addCourseExp.json',
  // 课程提问点赞
  COURSE_QA_LIKE: HOST + 'video-api/likeCourseQa.json',
  // 课程领取
  RECEIVE_COURSE: HOST + 'video-api/receiveCourse',
  // 课程观看记录上报
  RECORD_ACTIONLOG: HOST + 'video-api/recordActionLog',
  // 手动同步课程分数流水以及总分数信息
  UPDATA_COURSE_SCORE: HOST + 'video-api/manualSyncCourseScore.json',
  // 获取课程视频连接
  GET_VIDEO_URL: HOST + 'video-api/getVideoUrl',
  // 获取学习记录
  GET_STUDY_RECORD: HOST + 'video-api/getCourseRecord.json'
}

/**
 * 会员大返利
 */
const POST_GET_REBATE_LIST = HOST + 'rebate/getRebateList.json'

const POST_GET_REBATE_DETAIL = HOST + 'rebate/getRebateDetails.json'

const POST_REBATE_PRAISE = HOST + 'rebate/rebatePraise.json'

/** 分享海报落地页 */
const POST_ACTIVITY_SHARE_DETAILS = HOST + 'activityShare/getActivityShareDetails.json'

const POST_ACTIVITY_SHARE_RECORD = HOST + 'activityShare/addActivityShare.json'

/** 交流社区 */
const POST_COMMUNITY_GET_MODUL = HOST + 'community/getModulList.json'
const POST_COMMUNITY_GET_MODUL_LIST = HOST + 'community/getModulListNew.json'

const POST_COMMUNITY_GET_ARTICLE_LIST = HOST + 'community/getCommunityArticleList.json'

const POST_COMMUNITY_GIVE_PRAISE = HOST + 'search-api/forum/postOperate'

const POST_COMMUNITY_USER_OPERATE = HOST + 'search-api/forum/userOperate'

const POST_COMMUNITY_GET_ARTICLE_DETAIL = HOST + 'search-api/forum/getPostDetial'

const POST_COMMUNITY_GET_ARTICLE_COMMENT = HOST + 'search-api/forum/getPostDetialComment'

const POST_COMMUNITY_ADD_ARTICLE_COMMENT = HOST + 'search-api/forum/postComment'

const POST_COMMUNITY_GET_HOME_PAGE = HOST + 'community/getHomePage.json'

const POST_COMMUNITY_DELETE_ARTICLE = HOST + 'community/deleteCourseArticle.json'

const POST_COMMUNITY_UPDATE_STORE_LOCATION = HOST + 'community/updateStoreLocation.json'

const POST_COMMUNITY_GET_USER_INFO = HOST + 'community/getHomeUserInfo.json'

const POST_COMMUNITY_UNREAD_MESSAGE_NUM = HOST + 'community/getMessageNum.jfson'

const POST_COMMUNITY_GET_UNREAD_MESSAGE_LIST = HOST + 'community/getMessageList.json'

const POST_COMMUNITY_REMOVE_MESSAGE = HOST + 'community/removeMessage.json'

const POST_COMMUNITY_REPORT_TYPE_LIST = HOST + 'community/getCommunityReportTypeList.json'

const POST_COMMUNITY_REPORT_SUBMIT = HOST + 'community/communityReport.json'

const POST_COMMUNITY_ARTICLE_AUDIT_LIST = HOST + 'community/getCommunityArticleAuditList.json'

const POST_COMMUNITY_COMMENT_AUDIT_LIST = HOST + 'community/getCommunityArticleCommentAudit.json'

const POST_COMMUNITY_ARTICLE_COMMENT_DETAIL = HOST + 'community/getArticleCommentDetails.json'

const POST_COMMUNITY_REMOVE_ALL_MESSAGE = HOST + 'community/removeAllMessage.json'

const POST_COMMUNITY_GET_REWARD_TEXT_LIST = HOST + 'community/getRewardTextList.json'

const POST_COMMUNITY_COMMUNITY_REWARD_PAY = HOST + 'mall-api/order/quickCommunityPay.json'

const POST_COMMUNITY_DELETE_ARTICLE_COMMENT = HOST + 'community/deleteArticleComment.json'

const POST_COMMUNITY_TASKCENTER_USER_SIGN = HOST + 'communityTask/userSign.json'

const POST_COMMUNITY_TASKCENTER_INFO = HOST + 'communityTask/getTaskCenter.json'

const POST_COMMUNITY_TASKCENTER_TASK_LIST = HOST + 'communityTask/getTaskList.json'
const POST_COMMUNITY_SEND_POSTER = HOST + 'communityTask/sendPoster.json'

const POST_COMMUNITY_NEW_TOPIC = HOST + 'community/getNewTopic.json'
const POST_COMMUNITY_HOT_TOPIC = HOST + 'community/getRandomTopic.json'
const POST_COMMUNITY_CLICK_NEW_TOPIC = HOST + 'community/insertModuleBrowse.json'
const POST_COMMUNITY_ADD_SEARCH = HOST + 'community/addCommunitySearch.json'
const POST_COMMUNITY_SEARCH_LIST = HOST + 'community/searchCommunityList.json'
const GET_COMMUNITY_ADD_SEARCH_LIST = HOST + 'community/getCommunitySearchList.json'

// 合并之前社区零碎的用户信息接口
const POST_COMMUNITY_USERINFO = HOST + 'community/getCommunityUserInfo.json'

/** 红包任务-拆红包*/
const POST_COMMUNITY_TASKCENTER_REDENVELOPE = HOST + 'communityTask/redEnvelope.json'

/** 红包任务-拆红包后提交照片等信息*/
const POST_COMMUNITY_TASKCENTER_SUBMITVEHICLE = HOST + 'communityTask/submitVehicleTask.json'

/** 红包任务-获取红包列表数据*/
const POST_GETPACKETPECORDLIST = HOST + 'packetRecord/getPacketRecordList.json'

/** 红包任务-打开红包 */
const POST_TASKCENTER_OPENREDPACKET = HOST + 'packetRecord/receivePacket.json'

const POST_COMMUNITY_TASKCENTER_SIGN_DETAIL = HOST + 'communityTask/getSignInTable.json'

const POST_COMMUNITY_TASKCENTER_RECEIVE_STAR = HOST + 'communityTask/receiveStarBean.json'

const POST_COMMUNITY_TASKCENTER_SIGN_NOTICE = HOST + 'communityTask/userSignRemind.json'

const POST_COMMUNITY_TASKCENTER_STARS_DETAIL = HOST + 'communityTask/getStarBeanDetailed.json'

const POST_COMMUNITY_TASKCENTER_RECORD_SHARE = HOST + 'communityTask/userCommunityArticleShare.json'

const POST_COMMUNITY_TASKCENTER_EXCHANGE_PRODUCT_LIST = HOST + 'communityTask/getExchangeMdseList.json'

const POST_COMMUNITY_TASKCENTER_USER_EXCHANGE_PRODUCT = HOST + 'communityTask/userExchangeMdse.json'

const POST_COMMUNITY_TASKCENTER_BEANDETAIL_TYPELIST = HOST + 'communityTask/getfilterTypeList.json'

const POST_COMMUNITY_CASHQUESTION_CASH_ANSWER_HOME = HOST + 'cashQuestion/getCashAnswerHome.json'

const POST_COMMUNITY_CASHQUESTION_REMIND = HOST + 'cashQuestion/userCashAnswerRemind.json'

const POST_COMMUNITY_CASHQUESTION_SUBMIT = HOST + 'cashQuestion/userCashAnswerSubmit.json'

const POST_COMMUNITY_DAILY_CHECK_POSTER = HOST + 'community/getDailySignText.json'

const POST_COMMUNITY_SEND_ARTICLE = HOST + 'community/sentSignInArticle.json'

const POST_COMMUNITY_USER_SIGN_INFO = HOST + 'community/getUserSignIn.json'

const POST_COMMUNITY_ANNOUNCEMENT_LIST = HOST + 'community/getAnnouncementList.json'

const POST_COMMUNITY_USER_FOLLOW_TOGGLE = HOST + 'community/userConcerns.json'

const POST_COMMUNITY_USER_FOLLOW_LIST = HOST + 'community/getUserFollowList.json'

/**
 * H5活动页
 */
// 获取参与人活动详情页
const POST_GET_ACTIVITY_DETAIL = HOST + 'wxActivity/getActivitiesDetails.json'

// 获取受邀人活动详情页
const POST_GET_SHARE_ACTIVITY = HOST + 'wxActivity/getShareActivities.json'

// 新增活动推荐记录
const POST_ADD_USER_INVITATION = HOST + 'wxActivity/addUserInvitation.json'

// 活动下单 直接下单购买
const POST_ORDER_ACTIVITY_QUICK_PAY = HOST + 'mall-api/order/activityQuickPay.json'

/**
 * 会员礼品券
 */
// 获取会员礼品券列表
const POST_GET_MEMBER_GIFT_LIST = HOST + 'user-api/memberGiftCoupon/getMemberGiftCouponList.json'
const POST_GET_MEMBER_GIFT_LOG_LIST = HOST + 'user-api/memberGiftCoupon/getMemberGiftCouponLogList.json'

/**
 * 设备咨询管理
 */
// 员工设备咨询获取token
const POST_CONSULT_TOKEN = HOST + 'userConsultation/getRongToken.json'

// 员工端获取聊天用户列表
const POST_CONSULT_GET_USER_LIST = HOST + 'userConsultation/getUserList.json'

// 员工端发送消息
const POST_CONSULT_STAFF_SEND_MESSAGE = HOST + 'userConsultation/sysUserSendMessage.json'

// 用户设备咨询获取token
const POST_CONSULT_CUSTOM_TOKEN = HOST + 'common-api/userConsultation/userPurchaseEnquiry.json'

// 用户咨询发送信息
const POST_CONSULT_CUSTOM_SENT_MESSAGE = HOST + 'userConsultation/userAdvisoryMessage.json'

// 用户获取搜索问题推荐列表
const POST_CONSULT_CUSTOM_SEARCH_QUESTION = HOST + 'userConsultation/searchQuestion.json'

// 用户获取咨询聊天记录
const POST_CONSULT_CUSTOM_GET_CHAT_HISTORY = HOST + 'common-api/userConsultation/getUserChatRecordList.json'

/**
 * 维修案例编辑器
 */
// 获取用户草稿案例
const POST_GET_USET_REPAIR_CASE = HOST + 'repairCase/getUserRepairCase.json'

// 提交维修案例
const POST_SUBMIT_USER_REPAIR_CASE = HOST + 'search-api/forum/postRelease'

/**
 * 客户管理工具
 */
// 服务站抽奖列表
const POST_CUSTOMER_GET_DRAWLIST = HOST + 'appLuckDraw/getLuckDrawList.json'

// 抽奖活动详情
const POST_CUSTOMER_GET_DRAWDETAIL = HOST + 'appLuckDraw/getLuckDrawDetails.json'

// 抽奖活动奖品列表
const POST_CUSTOMER_GET_PRIZELIST = HOST + 'appLuckDraw/getPrizeList.json'

// 新增或修改抽奖活动
const POST_CUSTOMER_EDIT_LUCKDRAW = HOST + 'appLuckDraw/saveOrModifyLuckDraw.json'

// 删除抽奖活动
const POST_CUSTOMER_DEL_LUCKDRAW = HOST + 'appLuckDraw/deleteLuckDraw.json'

// 通知客户抽奖
const POST_CUSTOMER_INFORM_LUCKDRAW = HOST + 'appLuckDraw/addLuckDrawNotice.json'

// 服务站信息查询
const POST_CUSTOMER_GET_STATION_INFO = HOST + 'serviceStation/getServiceStation.json'

// 服务站信息编辑
const POST_CUSTOMER_EDIT_STATION_INFO = HOST + 'serviceStation/updateServiceStation.json'

// 小轨讲运营文章列表
const POST_CUSTOMER_OPERATION_ARTICLE_LIST = HOST + 'databi-api/report/data/list.json'

// 服务站动态列表
const POST_CUSTOMER_STATION_DYNAMIC_LIST = HOST + 'serviceStationDynamic/getServiceStationDynamicList.json'

// 删除当前动态
const POST_CUSTOMER_DEL_DYNAMIC_SINGLE = HOST + 'serviceStationDynamic/removeServiceStationDynamic.json'

// 客户信息查询
const POST_CUSTOMER_INFO = HOST + 'miniUser/getUserInfo.json'

// 客户记账列表查询
const POST_CUSTOMER_BOOK_KEEP_LIST = HOST + 'bookKeep/getUserBookKeep.json'

// 新增、修改客户记账信息
const POST_CUSTOMER_UPDATE_BOOK_KEEP = HOST + 'bookKeep/updateUserBookKeep.json'

// 修改客户信息
const POST_CUSTOMER_UPDATE_USERINFO = HOST + 'miniUser/updateUserInfo.json'

// 创建悬赏令
const POST_CUSTOMER_CREATEREWARD = HOST + 'serviceStation/createServiceStationReward.json'

// 悬赏令详情
const POST_CUSTOMER_REWARD_INFO = HOST + 'serviceStation/getServiceStationReward.json'

// 到店活动列表
const POST_CUSTOMER_ACTIVITY_LIST = HOST + 'serviceSActivity/getServiceSActivityList.json'

// 到店活动详情
const POST_CUSTOMER_ACTIVITY_DETAIL = HOST + 'serviceSActivity/getServiceSActivity.json'

// 到店活动通知用户
const POST_CUSTOMER_ADDUSERNOTICE = HOST + 'serviceSActivity/addUserNotice.json'

// 到店活动删除本次活动
const POST_CUSTOMER_ACTIVITY_DELETE = HOST + 'serviceSActivity/deleteUserNotice.json'

// 新建到店活动
const POST_CUSTOMER_ADD_ACTIVITY = HOST + 'serviceSActivity/addServiceSActivity.json'

// 获取服务站分享海报
const POST_CUSTOMER_STATION_POSTER = HOST + 'serviceStation/getServiceStationPoster.json'

// 获取活动分享海报
const POST_CUSTOMER_ACTIVITY_POSTER = HOST + 'serviceSActivity/getServiceSActivityPoster.json'

// 获取客户推荐记录
const POST_CUSTOMER_RECOMMEND_LIST = HOST + 'miniUser/getInvitationRecord.json'

// 客户管理工具首页客户类型查询列表
const POST_CUSTOMER_TYPE_LIST = HOST + 'report/getCustomerReportList.json'

// fms页面的底部广告位
const POST_FMS_BOTTOMAD = HOST + 'common-api/advertising/mark.json'

/**
 * 资料大全
 */
// 获取logo
const POST_DATAUM_LOGO = HOST + 'datashare/searchDataTree.json'

// 资料共享数据
const POST_DATAUM_LIST = HOST + 'datashare/queryDataFiles.json'

/**
 * 维修讲堂
 */
// 往期特训
const POST_LECTURE_ROOM_SHARE = HOST + 'training/getNewsArticleList.json'

// 本期特训
const POST_LECTURE_ROOM_CURRENT = HOST + 'training/getStationList.json'

// 获取站点详情
const POST_LECTURE_ROOM_DETAIL = HOST + 'training/getStationDetail.json'

// 扫码校验用户是否已经报名
const POST_LECTURE_ROOM_SIGNIN = HOST + 'trainingQrcode/verifyStationSigned.json'

// 扫码进行签到
const POST_LECTURE_ROOM_ATTEND = HOST + 'trainingQrcode/stationSigned.json'

// 扫码报名付费项
const POST_LECTURE_ROOM_PAY_ITEMS = HOST + 'trainingQrcode/payMdseItem.json'

// 培训红包分享
const POST_LECTURE_ROOM_RED_PACK = HOST + 'redpack/check.json'

// 领取红包
const POST_LECTURE_ROOM_OEPN_RED_PACK = HOST + 'redpack/receive.json'

// 评价建议
const POST_LECTURE_ROOM_ADVICE = HOST + 'training/getEvaluate.json'

// 创建订单
const POST_LECTURE_ROOM_CREATE_ORDER = HOST + 'training/createOrder.json'

// 校验是否已报名某站点
const POST_LECTURE_ROOM_CHECK_SHARE = HOST + 'training/verifyStationSigned.json'

// 精品课件列表
const POST_LECTURE_ROOM_COURSEWARE = HOST + 'training/getCourseList.json'

// 精品课件权限检测
const POST_LECTURE_ROOM_COURSESTATU = HOST + 'training/verifyCanViewCourse.json'
/**
 * 会员中心
 */
// 获取未完成订单，及未领取礼品数量
const POST_MEMBER_PERSONAL_MSG_COUNT = HOST + 'user-api/noOkOrderGiftNum.json'

// 校验验证码
const POST_MEMBER_PERSONAL_CHECK_CODE = HOST + 'common-api/common-api/member/checkCode.json'
// 获取会员中心二维码
const POST_MEMBER_SENDMESSAGE = HOSTOLDWX + 'api/common-api/member/sendMsg.json'
// 获取七牛token
const appGetQNToken = HOSTOLDWX + 'api/common-api/qiniu/uToken'
// 查询各功能使用次数
const POST_MEMBER_PERSONAL_USE_COUNT = HOST + 'user-api/myStatistical.json'

// 个人中心-获取个人信息
// const POST_MEMBER_PERSONAL_INFO = HOST + 'user-api/userinfo.json'
const POST_MEMBER_PERSONAL_INFO = HOST + 'page/userinfo/info'

// 字典
const DICR_LIST = HOST + 'blade-system/dict/dictionary?code=career'

// 个人中心-获取基本个人信息
// const POST_BASE_PERSONAL_INFO = HOST + 'user-api/userLoginInfo.json'
const POST_BASE_PERSONAL_INFO = HOST + 'page/userinfo/cacheinfo'

// 会员中心获取会员套餐列表
const POST_MEMBER_GETVIPPACKAGELIST = HOST + 'user-api/getVipPackageList.json'

// 修改用户信息
const POST_MEMBER_PERSONAL_SAVE = HOST + 'user-api/saveUserInfo.json'
// 修改用户手机号
const POST_MEMBER_USER_PHONE = HOST + 'user-api/certificationPhone.json'

// 修改信息第二次验证
const POST_MEMBER_PERSONAL_SAVE_WXAUTH = HOST + 'member/wxauth.json'

// 订单列表
// const POST_MEMBER_PERSONAL_ORDER_LIST = HOST + 'mall-api/order/orderList.json'
const POST_MEMBER_PERSONAL_ORDER_LIST = HOST + 'mall-api/order/list.json'
// 手机模板消息点击获取内容
const POST_MEMBER_PERSONAL_ORDER_LIST_Phone = HOST + 'telephone/getCustomerInfo.json'
// 手机模板拨打电话号码
const POST_MEMBER_PERSONAL_ORDER_LIST_Phone_To_Call = HOST + 'telephone/outCall.json'
// 订单详情
const POST_MEMBER_PERSONAL_ORDER_DETAIL = HOST + 'member/orderDetail.json'

// 获取赠品订单详情
const POST_MEMBER_GIFT_ORDER_DETAIL = HOST + 'mall-api/giftOrder/getGiftOrderApplyDetails.json'

// 获取赠品的信息
const MEMBER_GIFT_CONFIRM = HOST + 'wxpay/memberGiftApiConfirmNew.json'

// 获取底部的富文本内容
const POST_MEMBER_RICH_TEXT = HOST + 'user-api/getMemberIntro.json'

// 提交礼品的信息，并支付
const MEMBER_PAY_FOR_GIFT = HOST + 'mall-api/order/quickActivityPayForGift.json'

// 赠品申请
const POST_MEMBER_APPLYGIFTORDER = HOST + 'mall-api/giftOrder/applyGiftOrder.json'

// 取消订单
const POST_MEMBER_PERSONAL_CANCEL_ORDER = HOST + 'member/cancelOrder.json'
// 获取地址
const POST_MEMBER_PERSONAL_ADDRESS = HOST + 'user-api/findShippingAddressList.json'

// 获取门店地址
const POST_MEMBER_PERSONAL_STORE_ADDRESS = HOST + 'user-api/findStoreAddress.json'

// 保存门店地址
const POST_MEMBER_PERSONAL_STORE_ADDRESS_SAVE = HOST + 'user-api/saveStoreAddress.json'

// 保存地址
const POST_MEMBER_PERSONAL_ADDRESS_ADD = HOST + 'user-api/saveShippingAddress.json'

// 地址详情
const POST_MEMBER_PERSONAL_ADDRESS_detail = HOST + 'user-api/findShippingAddressById.json'

// 删除地址
const POST_MEMBER_PERSONAL_ADDRESS_DEL = HOST + 'user-api/delShippingAddress.json'

// 获取礼品
const POST_MEMBER_PERSONAL_GET_GIFT = HOST + 'member/myGift.json'

// 会员续费
const POST_MEMBER_PERSONAL_GET_JS_PARAMETER = HOST + 'wx/getJsParameter.json'

// 会员续费(new)
const POST_MEMBER_PERSONAL_GET_JS_PARAMETER_NEW = HOST + 'mall-api/wx/getJsParameter.json'

// 获取用户优惠券信息
const POST_MEMBER_PERSONAL_GET_JS_LOTTERY = HOST + 'wx/getLotteryRecord.json'

/**
 * 勋章中心相关
 */
// 勋章中心
const POST_MEMBER_PERSONAL_GET_MEDAL = HOST + 'user-api/medal/getMedalCenter.json'

// 勋章详情
const POST_MEMBER_PERSONAL_GET_MEDAL_DETAIL = HOST + 'user-api/medal/getMedalDetails.json'

// 勋章奖励
const POST_MEMBER_PERSONAL_GET_MEDAL_REWARD = HOST + 'user-api/medal/getMedalReward.json'

// 勋章奖励详情
const POST_MEMBER_PERSONAL_GET_REWARD_DETAIL = HOST + 'user-api/medal/getRewardDetails.json'

// 勋章奖励提现
const POST_MEMBER_PERSONAL_MEDAL_REWARD_WITHDRAW = HOST + 'user-api/medal/userPutForward.json'

// 勋章点赞信息
const POST_MEMBER_PERSONAL_GET_GATHER_PRAISE = HOST + 'user-api/medal/getGatherPraise.json'

// 勋章点赞
const POST_MEMBER_PERSONAL_MEDAL_GIVE_PRAISE = HOST + 'user-api/medal/givePraise.json'

// 勋章用户点赞列表
const POST_MEMBER_PERSONAL_USER_PRAISE_LIST = HOST + 'user-api/medal/getMedalUserPraiseList.json'

// 我的收藏
const POST_MEMBER_PERSONAL_COLLECT = HOST + 'user-api/fav/searchPage.json'

// 优惠券
const POST_MEMBER_PERSONAL_COUPON = HOST + 'mall-api/coupon/searchList.json'

// 门店基本信息
const POST_MEMBER_PERSONAL_STORES = HOST + 'user-api/storeInfo/getDetail.json'
const POST_GET_STORE_INFO_NEW = HOST + 'user-api/storeInfo/getStoreInfo.json'

// 保存门店基本信息
const POST_MEMBER_PERSONAL_STORES_SAVE = HOST + 'user-api/storeInfo/saveStoreInfo.json'

// 获取门店性质
const POST_MEMBER_PERSONAL_STORE = HOST + 'user-api/storeInfo/getStoreNature.json'

// 获取用户保存门店性质
const POST_MEMBER_PERSONAL_STORE_USER = HOST + 'user-api/storeInfo/getUserStoreNature.json'

// 保存门店性质
const POST_MEMBER_PERSONAL_STORE_SAVE = HOST + 'user-api/storeInfo/saveUserStoreNature.json'

// 获取业务范围
const POST_MEMBER_PERSONAL_STORES_BUSINESS = HOST + 'user-api/storeInfo/getProject.json'

// 获取用户保存业务范围
const POST_MEMBER_PERSONAL_STORES_BUSINESS_SAVE = HOST + 'user-api/storeInfo/getUserProject.json'

// 获取门店信息照片
const POST_MEMBER_PERSONAL_STORES_IMG = HOST + 'user-api/storeInfo/getUserImgs.json'

// 保存门店信息照片
const POST_MEMBER_PERSONAL_STORES_IMG_SAVE = HOST + 'user-api/storeInfo/saveStoreImg.htm'

// 保存门店信息照片-新
const POST_MEMBER_PERSONAL_STORES_IMG_SAVE_NEW = HOST + 'user-api/storeInfo/saveStoreImgNew.json'

// 每日签到
const POST_MEMBER_PERSONAL_DAILY_SINGIN = HOST + 'user-api/sign.json'

// 检查每日签到
const POST_MEMBER_PERSONAL_DAILY_SINGIN_CHECK = HOST + 'user-api/checkSign.json'

// 获取客服
const POST_MEMBER_PERSONAL_EXCLUSIVE = HOST + 'user-api/exclusive.json'

// 获取技能测试
const POST_SKILLS_TEST = HOST + 'user-api/myCert.json'

// 电喷百科获取文章列表
const POST_ELECT_ARTICLE_LIST = HOST + 'article/getArticleList.json'

// 电喷百科获取百科目录
const POST_ELECT_ARTICLE_CATALOGUELIST = HOST + 'article/getCatalogueList.json'

// 电喷百科搜索文章
const POST_ELECT_ARTICLE_SEARCHLIST = HOST + 'article/searchArticleList.json'

// 用户签到首页
const POST_MEMBER_PERSONAL_ACTIVITY_SIGN = HOST + 'activity/simple/sign.json'
// 用户签到结果页
const POST_MEMBER_PERSONAL_ACTIVITY_RESULT = HOST + 'activity/simple/sign/result.json'
/**
 * 商城
 */
// 获取商品分类列表
const POST_SHOPPING_PRODUCT_GETCATEGORYLIST = HOST + 'mall-api/product/getCategoryList.json'

// 获取专题列表
const POST_SHOPPING_PRODUCT_GETTOPICLIST = HOST + 'mall-api/product/getTopicList.json'

// 获取商品搜索关键词列表
const POST_SHOPPING_PRODUCT_GETKEYWORDLIST = HOST + 'mall-api/product/getKeywordList.json'

// 获取专题详情
const POST_SHOPPING_PRODUCT_GETTOPICINFO = HOST + 'shopping/product/getTopicInfo.json'

// 快捷支付
const POST_SHOPPING_ORDER_QUICKPAY = HOST + 'mall-api/order/quickPay.json'

// 商品详情
const POST_SHOPPING_PRODUCT_DETAIL = HOST + 'mall-api/product/getDetail.json'

// 商品列表
const POST_SHOPPING_INDEX_PRODUCT_LIST = HOST + 'mall-api/product/list.json'

// 商城顶部提示
const POST_SHOPPING_INDEX_TIPS_TEXT = HOST + 'shopping/mall-api/product/getTipsText.json'

// 购物车列表
const POST_SHOPPING_CART_LIST = HOST + 'mall-api/car/productList.json'

// 添加购物车
const POST_SHOPPING_CART_ADD = HOST + 'mall-api/car/addProduct.json'

// 删除购物车商品
const POST_SHOPPING_CART_DEL = HOST + 'mall-api/car/delProduct.json'

// 批量删除购物车商品
const POST_SHOPPING_CART_DELS = HOST + 'shopping/car/delProducts.json'

// 修改数量
const POST_SHOPPING_CART_UPDATE_NUM = HOST + 'mall-api/car/updateBuyNum.json'

// 提交订单
const POST_SHOPPING_CART_SUBMIT = HOST + 'mall-api/order/submit.json'

// 订单详情
const POST_SHOPPING_ORDER_DETAIL = HOST + 'mall-api/order/waitingPay.json'

// 取消订单
const POST_SHOPPING_CANCEL_ORDER = HOST + 'mall-api/order/cancelOrder.json'

// 获取图片
const POST_SHOPPING_ORDER_GET_IMG = HOST + 'mall-api/order/getPaymentReceiptList.json'

// 图片上传
const POST_SHOPPING_ORDER_IMG_UPLOAD = HOST + 'mall-api/order/uploadPaymentReceipt.json'

// 获取支付
const POST_SHOPPING_ORDER_JS_PARAMETER = HOST + 'mall-api/order/toPay.json'

// 修改订单地址
const POST_SHOPPING_ORDER_UPDATE_ADDRESS = HOST + 'mall-api/order/updateAddress.json'

// 获取分期付款信息页面
const POST_SHOPPING_ORDER_ONLINE_STAG = HOST + 'wx/findOrderOnlineStag.json'

// 在线分期消费接口
const POST_WXAUTH_ONLINE_STAGING = HOST + 'wx/onlineStaging.json'

/**
 * 报表
 */
// 获取文件夹
const POST_SYS_REPORT_FOLDER = HOST + 'databi-api/folder/list.json'
// 获取文件夹下报表
const POST_SYS_REPORT_FOLDER_LIST = HOST + 'databi-api/report/list.json'

// 获取报表查询条件
const POST_SYS_REPORT_QUERY_PARAMS = HOST + 'databi-api/param/list.json'

// 获取报表内容
const POST_SYS_REPORT_LIST = HOST + 'report/getAdminReportData.json'

// 产品帮助与反馈列表
const POST_SYS_PRODUCT_HELP_ADN_FEEDBACK = HOST + 'document/queryList.json'

// 获取演示模块报表内容
const POST_SYS_REPORT_LIST_TWO = HOST + 'databi-api/report/data/list.json'

// 产品帮助与反馈详情
const POST_SYS_PRODUCT_HELP_ADN_FEEDBACK_DETAIL = HOST + 'common-api/document/getDocumentById.json'
// 产品帮助与反馈地点赞
const POST_SYS_PRODUC_PARISE = HOST + 'document/praise.json'
// 产品帮助与反馈获取留言列表
const POST_SYS_PRODUC_GETDOCUMENTCOMMENTBYDOCUMENTId = HOST + 'common-api/document/getDocumentCommentByDocumentId.json'
// 产品帮助与反馈新增反馈
const POST_SYS_PRODUC_FEEDBACK_ADD = HOST + 'feedback/add.json'
// 产品帮助与反馈新增留言
const POST_SYS_PRODUC_FEEDBACK_ADDCOMMENT = HOST + 'document/addComment.json'

// 预约页面相关
const POST_ADD_ACTIVITY_RESERVATION = HOST + 'activityReservation/addActivityReservation.json'

// 在线问答相关

// 获取选择题的id
const POST_CHOSEID = HOST + 'common-api/qa-api/vipqa/getQuestionCheck.json'

// 无法回答
const POST_UNANSWER = HOST + 'common-api/qa-api/vipqa/updateCheckIsReply.json'
// 提交答案后的处理
const POST_CHECK_REPLY = HOST + 'common-api/qa-api/vipqa/updateCheckReply.json'
// 获取帮助文档
const POST_QUESTION_HELP = HOST + 'common-api/qa-api/vipqa/getQuestionCheckHelp.json'
// 获取页面输入框开关
const POST_CUS_BTN = HOST + 'common-api/qa-api/vipqa/getcusInputBtn.json'

// 获取问答聊天列表
const POST_GET_GETChATLIST = HOSTOLDWX + 'api/common-api/qa-api/vipqa/getChatList.json'
// 获取问答详情
const POST_GET_GETDETAIL = HOSTOLDWX + 'api/common-api/qa-api/vipqa/getDetail.json'
// 打赏预支付接口
const POST_GET_DASHANG = HOSTOLDWX + 'api/common-api/qa-api/vipqa/wxpay/dashang.json'
// 用户对问题评分
const POST_GET_SCORE = HOSTOLDWX + 'api/common-api/qa-api/vipqa/score.json'

// 关闭问答
const POST_GET_CLOSE = HOSTOLDWX + 'api/common-api/qa-api/vipqa/close.json'
// 用户追问

const POST_GET_QUESTIONING = HOSTOLDWX + 'api/common-api/qa-api/vipqa/questioning.json'

/**
 * 内置
 */
// const GET_WXSDK_CONFIG = HOSTOLD + 'ajaxmgiftactivesave.json';

// 获取sdk
const POST_COMMON_WXSDK_CONFIG = NEWHOST + 'common-api/common/jssdk.json'

// 获取用户SESSION
const POST_COMMON_GET_SEESION = NEWHOST + 'user-api/common/getkaxiuyunSession.json'
//
const GET_WX_WORK_SESSION = NEWHOST + 'user-api/common/getQyKaxiuyunSession.json'
// 获取卡修宝典企业微信用户session
const GET_WX_WORK_GGZJ_SESSION = NEWHOST + 'user-api/common/getGGQyKaxiuyunSession.json'

/**
 * URL 参数
 * @type {string}
 */
const POST_URL_PARAMS_CURR_ORDER = 'POST_URL_PARAMS_CURR_ORDER'

const LOCAL_STORAGE_AUTH_LOGIN_FLAG = 'AUTH_LOGIN_FLAG'

/**
 * 课程直播评价
 */
const POST_BROADCAST_COURSE_LIVING = HOSTCOMMON + 'broadcast/video-api/living.json'

const POST_BROADCAST_ANCHOR_CHAT = HOSTCOMMON + 'broadcast/anchor/chat.json'

/**
 * APP
 */
// 发送获取验证码
const POST_APP_SEND_CODE = NEWHOST + 'common-api/app/sendMsgForApp.json'
// 登录
const POST_APP_LOGIN = NEWHOST + 'user-api/app/checkLoginForApp.json'

// 微信授权登录验证
const POST_WX_AUTH_LOGIN_VALIDATE = NEWHOST + 'user-api/app/wxLoginValidatePhone.json'

// 微信授权登录
const POST_WX_AUTH_LOGIN = NEWHOST + 'user-api/app/wxLoginForApp.json'

// 微信绑定手机号 获取验证码接口
const POST_WX_SEND_MESSAGE = NEWHOST + 'common-api/app/sendMsgForAppWx.json'

// NEW登录
const POST_APP_NEW_LOGIN = NEWHOST + 'user-api/app/doLogin.json'

// 退出
const POST_APP_LOGIN_OUT = HOST + 'user-api/app/logout.json'

// 消息列表
const POST_APP_MESSAGE_LIST = HOST + 'common-api/app/messageList.json'

const POST_APP_GETPDF = HOSTOLD + 'wxauth/searchDataTree/fileView/pdf.json'

// 通過code獲取APPid
const POST_GET_GETKLLOPENIDBYCODE = NEWHOST + 'user-api/common/getKllOpenIdByCode.json'
const POST_GET_GETKALULIAPPID = NEWHOST + 'common-api/common/getKaluliAppId.json'

// 扫码付款预支付接口
const POST_GET_QUICKACTIVITYPAY = HOST + 'mall-api/order/quickActivityPay.json'
// 获取最近5笔交易记录接口
const POST_GET_GETUSERPAYRECORD = HOST + 'mall-api/order/getUserPayRecord.json'

// 获取问卷调查题目
const POST_GET_QUESTIONNAIRE = HOST + 'common-api/surveyQuestion/detail.json'
// 上传问卷结果
const POST_SUB_QUESTIONS = HOST + 'surveyQuestion/answer.json'
// 提交考试结果
const POST_EXAM_RESULT = HOST + 'surveyQuestion/submitQuestion.json'
// 考试提交当前地理位置
const POST_CURENT_LOCATION = HOST + 'common-api/userLocation/save.json'
// 查看试卷结果
const POST_QUESTION_RESULT = HOST + 'surveyQuestion/questionResult.json'

// 文档页面获取推荐fms流
const GET_RECOMMEND_FMS_LIST = HOST + 'document/getRecommendFmsList.json'

// 获取fms专题列表
const GET_SUBJECT_LIST = HOST + 'document/getSubjectList.json'

// 获取地推人员信息
const GET_CRM_SALEINFO = NEWHOST + 'common/loadSysUser.json'

// 砍价有关的接口
const CUT_PRICE = {
  // 获取砍价相关商品的信息
  GET_CUTPRICE_INFO: HOST + 'mall-api/bargain/bargainInfo.json',
  // 获取砍价金额
  GET_CUT_NUM: HOST + 'mall-api/bargain/bargainNum.json',
  // 支付定金
  PAY_CUT_PRICE: HOST + 'mall-api/order/bargainQuickPay.json',
  // 支付完成回调
  PAY_CUT_PRICE_CALLBACK: HOST + 'bargain/payCallback.json',
  // 帮砍信息
  GET_HELP_CUTPRICE_INFO: HOST + 'mall-api/bargain/helpBargainInfo.json'
}

// 修车问答相关接口
const REPAIR_ASKANSWER = {
  // 获取修车问答列表
  GET_REPAIRCASE_LIST: HOST + 'community/repairCase/list.json',
  // 判断是否订阅了修车问答
  ISSUBSCRIPT: HOST + 'community/repairCase/getSubscription.json',
  // 订阅与取消订阅
  SUBSCRIPTION: HOST + 'community/repairCase/subscription.json',

  // 获取修车问答详情
  REPAIRCASE_DETAIL: HOST + 'community/repairCase/detail.json',

  // 获取提问对应的回答列表
  GET_ABSWERLIST: HOST + 'community/repairCase/answerList.json',

  // 我来回答_发帖
  SENTARTICLE: HOST + 'community/sentArticle.json',

  // 获取用户星豆数量
  GETBEANNUM: HOST + 'community/repairCase/getBeanNum.json',

  // 提交新的问答或者存草稿
  ADDNEWASK: HOST + 'community/repairCase/add.json',
  // 获取草稿
  GETDREFT: HOST + 'community/repairCase/getDreft.json',
  // 审核新修车问题
  REVIEW: HOST + 'community/repairCase/review.json',
  // 获取审核问题详情
  GET_REVIEW_DETAIL: HOST + 'community/repairCase/reviewDetail.json',
  // 采纳此回答
  ADOPT_ANSWER: HOST + 'community/repairCase/adopt.json',
  // 是否有最新修车问答
  ISHASNEWQUES: HOST + 'community/repairCase/hasNewQues.json',
  // 获取 已审核且未采纳答案的问题 总数
  NO_ADOPT_NUM: HOST + 'community/repairCase/getTotalNotAdoptArticle.json',
  // 获取修车问答贴的最新补充
  GET_LATEST_COMMENT: HOST + 'community/repairCase/getLatestComment.json'

}

// 消息订阅相关接口
const MESSAGETAKE = {
  // 获取订阅消息
  GET_ALLMESSAGE: HOST + 'message/getAllSubscribedTopsMessage.json',
  // 获取二级消息列表
  GET_SECONDLEVEL: HOST + 'message/getAllSedLelMessageByMessageId.json',
  // 订阅或取消订阅的点击操作
  CONTROLTAKE: HOST + 'message/clickSubscribe.json'
}
// 支付宝支付

// 消息中心
const MESSAGEBOX = {
  GET_BOX_LIST: HOST + 'user-api/message/getMessageBoxList.json',
  GET_MESSAGE_LIST: HOST + 'user-api/message/getMessageList.json',
  SET_MESSAGE_READ_STATUS: HOST + 'user-api/message/setMessageReadStatus.json  '
}

const ALIPAYAPP = {
  // 发送链接给app
  SENDURLTOAPP: HOST + 'wx/wxAlipayPayApp.json',
  // 获取唤起支付宝需要的参数
  GETALIPAYCOMMON: HOST + 'mall-api/alipay/alipayPayCommon.json',
  // 订单页获取支付宝签名
  ORDERALIPAY: HOST + 'alipay/alipayPayApp.json'
}
// 查看在线问答名词详情
const TREMDETAIL = HOST + 'faltCode/getFaultTermContent.json'

// 小轨调查跳转在线问答
const ADD_ONLINEQUE = HOST + 'common-api/qa-api/vipqa/saveVipQuestion.json'

/** 以旧 换新 */
const RENEW = {
  // 获取销售用户角色
  GETUSERROLE: HOST + 'mall-api/adminSell/OldChangeNewApply/getUserRole.json',
  // 获取以旧换新商品列表
  GETMDSELIST: HOST + 'mall-api/adminSell/OldChangeNewApply/getMdseList.json',
  // 获取客户信息（判断客户是否存在）
  GETCUSTOMERINFO: HOST + 'mall-api/adminSell/OldChangeNewApply/getUserInfo.json',
  // 查看销售的申请记录列表
  GETAPPLYLIST: HOST + 'mall-api/adminSell/OldChangeNewApply/getApplyList.json',
  // 查看申请记录列表的每一项详情
  GETMDSEAPPLYDETAIL: HOST + 'mall-api/adminSell/OldChangeNewApply/getMdseApplyDetail.json',
  // 销售更新快递单号
  UPDATEERPRESSNUM: HOST + 'mall-api/adminSell/OldChangeNewApply/updateExpressNumber.json',
  // 申请以旧换新
  SUBMITAPPLY: HOST + 'mall-api/adminSell/OldChangeNewApply/submitApply.json',
  // 申请以旧换新库存
  APPLYSTOCK: HOST + 'mall-api/adminSell/OldChangeNewApply/updateMdseStock.json',
  // 查询及添加申请记录
  ADDSEARCHLOG: HOST + 'mall-api/adminSell/OldChangeNewApply/addSearchLog.json',

  // 客户端获取商品信息
  CUSTOMERGWTMDSEDETAIL: HOST + 'mall-api/user/OldChangeNewApply/getUserMdseApplyDetail.json',
  // 修改申请信息
  USERUPDATEAPPLY: HOST + 'mall-api/user/OldChangeNewApply/userUpdateApplyDetail.json',
  // 埋点
  ADDCONFIRMLOG: HOST + 'mall-api/user/OldChangeNewApply/addMdseConfirmLog.json'
}

/**
 * 地推CRM接口
 */
// 获取客户信息
const POST_GRABUSERINFO = HOST + 'grabSingle/grabSingleUserInfo.json'
// 查询跟进记录
const POST_QUERYDATALISTROW = HOST + 'grabSingle/queryDataListRow.json'
// 地推销售抢单
const POST_GRABUSER = HOST + 'grabSingle/grabUserToSysUser.json'

/*
  组团抽会员活动
*/
// 获取当前用户的信息
const POST_USERINFOS = HOST + 'act/select4User'
// 参加活动接口
const POST_JOINTEAM = HOST + 'act/joinAct'
// 参加活动的记录
const POST_JOINRECORD = HOST + 'act/actHis'

/*
  技能证书查询
*/
// 首页
const POST_CERTINFOS = HOST + 'cert/index'
// 查询证书
const POST_SELECTLIST = HOST + 'cert/selectList'
/*
  微信首页升级
*/
const HOME_PAGE = {
  // 获取首页信息 (直播，消息，模块，角标)
  POST_GET_HOME_PAGE_INFO: NEWHOST + 'common-api/app/getHomePageInfo.json',
  // 获取5.2首页广告位数据（轮播，及二分之一广告）
  POST_GET_HOME_PAGE_AD_LIST: NEWHOST + 'common-api/advertPosition/getHomePageAdvertList.json',
  // 获取宝箱数据
  GET_CHEST_DATA: NEWHOST + 'common-api/app/getHomePageTreasureChest.json',
  // 修车tab，获取直播预约列表
  POST_GET_BROAD_LIST: NEWHOST + 'api/video-api/live/list.json',
  // 获取广告位集合
  POST_GET_SIGN_LIST: NEWHOST + 'api/common-api/advertPosition/getSignList.json',
  // 获取畅享卡到期时间及课程信息
  POST_GET_COURSE_CLASSIFY: NEWHOST + 'api/benbenOnlinevideo-api/getCourseClassifyList.json',
  // 获取热门课程
  POST_GET_HOT_CLASS: NEWHOST + 'api/benbenOnlinevideo-api/getHotCourseList.json',
  // 购买设备
  POST_BUY_DEVICE_LIST: NEWHOST + 'api/common-api/tabBuyingEquipment/list.json',
  // 获取可配置模块详细信息
  POST_GET_HOME_PAGE_TAB: NEWHOST + 'api/common-api/getHomePageModule.json'
}
/*
  社区任务中心接口(5.2新增)
*/
const COMMUNITY_TASKCENTER_NEW = {
  // 获取宝箱领取情况
  GET_CHEST_DATA: NEWHOST + 'api/communityTask/getUserTreasureChestStatus.json',
  // 点击开宝箱获取奖品
  OPEN_CHEST_FN: NEWHOST + 'api/communityTask/userTreasureChest.json',
  // 获取社区最常访问用户列表
  GET_BROWSE_USER_LIST: NEWHOST + 'api/community/getBrowseUserList.json',
  // 获取聚合模块帖集合
  GET_JH_MODULE_LIST: NEWHOST + 'api/community/getJHModuleArticleList.json'
}
/*
  修车页
*/
const CARREPAIR = {
  // 获取资料数量
  POST_GET_TREE_SHARE_NUM: NEWHOST + 'api/treeShare/getTreeShareNum.json',
  // 获取已解决在线问答列表
  POST_GET_SEARCHPAGE: NEWHOST + 'api/common-api/qa-api/vipqa/searchPage.json',
  // 获取未解决在线问答列表
  POST_GET_NEW_SEARCHPAGE: NEWHOST + 'api/common-api/qa-api/vipqa/newSearchPage.json'
}
/*
  资料大全页
*/
const CORPUS = {
  // 获取资料数量
  HISTORY_LIST: NEWHOST + 'api/treeShare/getSosoRecordList.json',
  // 新增搜索记录
  ADD_HISTORY: NEWHOST + 'api/treeShare/addSosoRecord',
  // 获取快捷入口数据
  // GET_QUICK_LIST: NEWHOST + 'common-api/app/getProductQuickClassifyList.json'
  GET_QUICK_LIST: NEWHOST + 'common-api/app/getProductQuickClassifyList.json'
}

// 回退订单详情
const POST_ORDER_BACK_DETAIL = HOST + 'orderBack/detail.json'
// 回退订单更新
const POST_ORDER_BACK_UPDATE = HOST + 'orderBack/update.json'

// 产品库2.0 - 电路图大全
// 根据pageType获取对应folderId
const POST_GET_FOLDER_ID = HOST + 'search-api/product/getFolderidByPageType.json'
// 添加搜索记录
const POST_ADD_SOSO_RECORD = HOST + 'treeShare/addSosoRecord'

// // 添加搜索记录
// const POST_ADD_SOSO_RECORD = HOST + 'treeShare/addSosoRecord'

// 产品库搜索记录
const POST_PRODUCT_RECORD_LIST = HOST + 'treeShare/getProductSosoRecordList'

// 产品库搜索记录
const XNY_POST_PRODUCT_RECORD_LIST = HOST + 'treeShare/getXnyProductSosoRecordList'

// 获取后处理类型列表
const POST_PRODUCT_HCL_MODULE_LIST = HOST + 'search-api/product/getHCLMoudleList.json'
// 电路图列表
const POST_CIRCUIT_DIRECTORY_LIST = HOST + 'search-api/product/getCircuitDirectoryList.json'
// 获取第一层车辆信息列表
const POST_FIRST_VEHICLE_LIST = HOST + 'search-api/product/getFirstVehicleList.json'
// 获取子集车辆字典或者资料列表
const POST_SUB_VEHICLE_DATA_LIST = HOST + 'search-api/product/getSubVehicleAndDataList.json'
// 获取子集车辆字典或者资料列表接口新
const POST_SUB_VEHICLE_DATA_LIST_NEW = HOST + 'search-api/product/getSubVehicleAndDataNewList.json'
// 获取第一层车辆字典字母排序
const POST_SUB_VEHICLE_LIST_SORT = HOST + 'search-api/product/getFirstVehicleListByLetterSort.json'
// 获取二级和三级子集车辆字典列表
const POST_SUB_LEVE_VEHICLE_LIST = HOST + 'search-api/product/getSubLevelVehicledoubleList.json'
// 获取通用资料
const POST_CURRENCY_DATA_LIST = HOST + 'search-api/product/getCurrencyDataList.json'
// 获取通用资料新
const POST_CURRENCY_DATA_LIST_NEW = HOST + 'search-api/product/getCurrencyDataNewList.json'

// 电喷百科分类列表
const POST_GETENTRYCLASSLIST = HOST + 'search-api/entryVocabulary/getEntryClassifyList.json'
// 电喷百科获取词条列表
const POST_GETENCYLIST = HOST + 'search-api/entryVocabulary/gettryClassifyList.json'
// 电喷百科-获取词条详情
const POST_GET_ENCYDETAIL = HOST + 'search-api/entryVocabulary/getEntryVocabularyDetails.json'

// 故障码查询
const POST_FAULT_DES_LIST = HOST + 'search-api/crfaultcode/faultDesList'
// 搜索故障码
const POST_FAULT_SEARCH = HOST + 'search-api/crfaultcode/search.json'
// 故障码详情
const GET_FAULT_CODE_DETAIL = HOST + 'search-api/crfaultcode/searchFaultCodeDetail'
// 故障码详情(新)
const GET_FAULT_CODE_DETAIL_NEW = HOST + 'search-api/crfaultcode/detailSearchFaultCode'
// 故障码详情(新2)
const GET_FAULT_CODE_DETAIL_NEW2 = HOST + 'search-api/crfaultcode/detailSearchFaultCodeSimple'
// 故障码详情(新2)
const XNY_GET_FAULT_CODE_DETAIL_NEW2 = HOST + 'search-api/xnyfaultcode/detailSearchFaultCodeSimple'
// 尿素泵
const GET_UREA_LIST = HOST + 'search-api/crfaultcode/getUreaList'
// 尿素泵(新)
const GET_UREA_LIST_NEW = HOST + 'search-api/crfaultcode/listUrea'
// 尿素泵（新2）
const GET_UREA_LIST_NEW2 = HOST + 'search-api/crfaultcode/listUreaSimple'
// 查看排查步骤
const GET_TROUBLE_SHOOT_STEP = HOST + 'search-api/crfaultcode/troubleshootStep'
// 排查步骤具体内容
const GET_TROUBLE_SHOOT_STEP_CONTENT = HOST + 'search-api/crfaultcode/troubleshootStepContent'
// 新故障码排查步骤具体内容
const TROUBLESHOOT_STEP_CONTENT_BY_VEHIDIRID = HOST + 'search-api/crfaultcode/troubleshootStepContentByVehiDirId'

// 新故障码排查步骤具体内容
const XNY_TROUBLESHOOT_STEP_CONTENT_BY_VEHIDIRID = HOST + 'search-api/xnyfaultcode/troubleshootStepContentByVehiDirId'

// 故障案例
const POST_DATA_SHARE = HOST + 'search-api/crfaultcode/dataShare'
// 排查步骤反馈
const POST_FAULT_REASON_FEEDBACK = HOST + 'search-api/crfaultcode/faultReasonFeedback.json'

// 获取微信顶部引导快捷分类
const GET_WXTOP_GIIDEQUICK_CLASSIFYLIST = NEWHOST + 'common-api/app/getWxTopGuideQuickClassifyList.json'
// 获取全局提醒卡片快捷分类
const GET_HOME_PAGE_REMIND = NEWHOST + 'common-api/app/getHomePageRemind.json'
// 获取车身模块列表
const POST_VEHICLE_MODULE_LIST = HOST + 'search-api/product/getVehicleModuleList.json'
const POST_VEHICLE_PART_AND_DATA_LIST = HOST + 'search-api/product/getVehiclePartFileTypeAndDataList.json'

const getDataDetails = HOST + `search-api/product/getDataDetails`
const getLowerStrataDataList = `${HOST}search-api/product/getLowerStrataDataList`
const getProductDirectoryList = `${HOST}search-api/product/getProductDirectoryList`
const searchDataList = `${HOST}search-api/product/searchDataList`
const getTypeList = `${HOST}search-api/product/getTypeList`
const getTypeSearchList = `${HOST}search-api/product/getTypeSearchList`
const getSearchListByType = `${HOST}search-api/product/getSearchListByType`
/*
  * 搜搜改版
*/
// 获取节点模块
const POST_SEARCHVHEIC_DIC_LIST = HOST + 'search-api/search/searchVheicleDictionaryList.json'
// 统一判断查看资料的权限
const POST_JUDGE_POWER = HOST + 'user-api/memberDataPower'
// 对于跳转到老soso的链接是否需要replace到新的地址
const POST_IS_REPLACE_TO_NEWSOSO = NEWHOST + 'common-api/app/versionGray.json'
// 新的故障码搜索
// const POST_FAULT_SEARCH_NEW = HOST + 'search-api/crfaultcode/newSearch.json'
const POST_FAULT_SEARCH_NEW = HOST + 'search-api/crfaultcode/querySimple'
// 新的故障码搜索
const XNY_POST_FAULT_SEARCH_NEW = HOST + 'search-api/xnyfaultcode/querySimple'
// 搜索智能推荐列表
const POST_SEARCH_KEYWORD_LIST = HOST + 'search-api/search/searchKeyWordList.json'
// 搜索智能匹配详情
const POST_SEARCH_KEYWORD_DETAIL = HOST + 'search-api/search/searchKeyWordDetail'
// 搜索路径列表
const POST_SEARCH_PATH_LIST = HOST + 'search-api/search/searchPathList'
// CR故障码
const POST_GET_CAR_TAB_INFO = HOST + 'search-api/crfaultcode/getCrTabInfo'

/**
 * 问答
 */
// 获取问答草稿
const GET_QUESTION_DRAFT = HOST + 'common-api/qaQuestion/getQuestionDraft.json'
// 获取车辆、发动机、ECU品牌、根据品牌id, 获取类型集合
const GET_QA_ASK_PARAMS = HOST + 'common-api/qaQuestion/getQaAskParams.json'
// 新增/编辑问题
const SAVE_QUESTION = HOST + 'common-api/qaQuestion/saveQuestion.json'
// 获取悬赏金额列表
const GET_REWARD_AMOUNT_LIST = HOST + 'common-api/qaQuestion/getOfferRewardAmountList.json'
// 新问答打赏
const QA_QUESTION_QUICK_PAY = HOST + 'mall-api/order/qaQuestionQuickPay.json'
// 获取问题详情
const GET_QUESTION_DETAIL = HOST + 'common-api/qaQuestion/getQuestionDetail.json'
// 根据问题获取会话列表
const GET_VOS_BY_QUESTION_NO = HOST + 'common-api/qaMyQuestion/getVosByQuestionNo.json'
// 获取我的问题(提问/接单)列表
const GET_QA_MY_QUESTION = HOST + 'common-api/qaMyQuestion/getQaMyQuestionVo.json'
// 获取微信通知开启状态
const GET_WX_OPEN_FLAG = HOST + 'common-api/qaMyQuestion/getWxOpenFlag.json'
// 获取当前新消息通知状态
const GET_CURRENT_NOTICE_FLAG = HOST + 'common-api/qaSquare/getCurrentNoticeFlag.json'
// 开启/关闭新消息通知
const CHANGE_OPEN_NOTICE_FLAG = HOST + 'common-api/qaSquare/changeOpenNoticeFlag.json'
// 获取我的问答列表（包含两组列表、未被接单问题列表/会话列表）、采纳率、是否开启问答通知、数字角标
const GET_QA_MY_QUESTION_LIST = HOST + 'common-api/qaMyQuestion/getQaMyQuestionListVo.json'
// 获取广场问答设置系列参数及已有广场问答设置
const GET_SQUARE_NOTICE_PARAMS = HOST + 'common-api/qaSquare/getSquareNoticeParams.json'
// 编辑问答设置
const SAVE_SQUARE_NOTICE = HOST + 'common-api/qaSquare/saveSquareNotice.json'
// 获取问题广场列表
// const GET_QA_QUESTION_SQUARE_LIST = HOST + 'common-api/qaSquare/getQaQuestionSquareList.json'
const GET_QA_QUESTION_SQUARE_LIST = HOST + 'common-api/qaSquare/questionSquareList.json'
// 获取抢单数据
const GET_UN_ACCEPT_QUESTION_DATA = HOST + 'common-api/qaQuestion/getUnAcceptQuestionData.json'
// 使用加速卡
const USE_ACCELERATOR_CARD = HOST + 'common-api/qaQuestion/useAcceleratorCard.json'
// 使用星豆
const USE_STAR_BEAN = HOST + 'common-api/qaQuestion/useStarBean.json'
// 接单
const GRAB_QA_QUESTION = HOST + 'common-api/qaQuestion/grabQaQuestion.json'
// 获取问答通知和开启广场弹框
const QUERY_NOTICE_AND_QRCODE = HOST + 'databi-api/report/data/list.json'
// 新增qa_新问答-用户日志信息
const QA_USERLOG_ADD = HOST + 'common-api/qaUserLog/add.json'
// 获取是否有新问题产生
const GET_NEW_QUESTION_FLAG = HOST + 'common-api/qaSquare/getNewQuestionFlag.json'
// 发送会话消息
const SEND_MESSAGE = HOST + 'common-api/qaDialogue/sendMessage.json'
// 获取会话消息列表
const GET_DIALOGUE_MESSAGE_LIST = HOST + 'common-api/qaDialogue/getDialogueMessageList.json'
// 采纳
const ACCEPT_ANSWER = HOST + 'common-api/qaQuestion/acceptAnswer.json'
// 采纳
const GET_HOME_PAGE_MSG_NUM = HOST + 'common-api/qaMyQuestion/getHomePageMsgNum.json'
// 加速卡
const GET_QA_QUESTION_CARD_DATA = HOST + 'common-api/qaQuestionCard/getQaQuestionCardData.json'
// 领取加速卡
const RECEIVE_CARD = HOST + 'common-api/qaQuestionCard/receiveCard.json'
// 能否新增问题
const CAN_NEW_QUESTION = HOST + 'common-api/qaQuestion/canNewQuestion.json'
// 问答打电话
const QA_OUT_CALL = HOST + 'common-api/qaDialogue/qaOutCall.json'
// 获取便携王购买尿素商品列表
const GET_PARTS_COLL_MDSE_LIST = HOST + 'mall-api/parts/getPartsCollocationMdseList.json'
// 便携王快捷支付
const MDSPART_QUICK_PAY = HOST + 'mall-api/order/equipmentPartsQuickPay.json'
// 编写王优惠券
const GET_EQUIPMENT_COUPON_LIST = HOST + 'mall-api/coupon/getEquipmentCouponList.json'
// 权益兑换
const GET_EXCHANGE_EQUITY = HOST + 'user-api/equityExchange/exchangeEquity.json'
// 获取权益详情（还可以判断码存在不存在）
const GET_EXCHANGE_DDETAIL = HOST + 'user-api/equityExchange/getEquityDetails.json'
// 获取用户归属权益列表
const GET_EQUITY_LIST = HOST + 'user-api/equityExchange/getEquityList.json'
// 核销码表-扫码记录
const ADD_EQUITY_LOG = HOST + 'user-api/equityExchange/addEquityExchangeLog.json'

// 获取问答首页推荐问题列表或者我的会话列表
const GET_RECOMMAND_INFOS = HOST + 'common-api/v1.1/qa/get_recommand_infos'
// 获取问题广场最新一条数据
const GET_LAST_QA_INFO = HOST + 'common-api/v1.1/qa/get_last_qa_info'
// 获取问答小助手配置
const GET_QA_ASSISTANT_PAGE = HOST + 'common-api/v1.1/qa/get_qa_assistant_page'
// 获取问答小助手信息
const LIST_QA_ASSISTANT_INFOS = HOST + 'common-api/v1.1/qa/list_qa_assistant_infos'
// 获取是否有加速卡可以领取
const CAN_GAIN_ACCELERATOR_CARD = HOST + 'common-api/v1.1/qa/can_gain_accelerator_card'
// 协议类点击记录
const READING_PROTOCOL_RECORD = NEWHOST + 'user-api/readingProtocolRecord/add.json'
// 免电话营销用户登记
const TELEMARK_RECODE = HOST + 'user-api/telemarketingFreeUsersRecord/add.json'
// 新增悬赏
const ADD_SYS_REWARD = HOST + 'common-api/qaQuestion/addSysReward.json'
// 隐藏系统问答
const HIDE_SYS_QUESTION = HOST + 'common-api/qaQuestion/systemHideQuestion.json'

// 问答1.4
// 获取广场问答设置信息
const GET_SQUARE_NOTICE = HOST + 'common-api/v1.4/qa/get_square_notice'
// (非)工作时间接单(开启、关闭) 设置
const QA_GRAB_NOTICE_SAVE = HOST + 'common-api/v1.4/qa/qa_grab_notice_save'
// 取消问题订单
const CANCEL_QUESTION = HOST + 'common-api/v1.4/cancel_question'
// 关闭问题订单
const CLOSE_QUESTION = HOST + 'common-api/v1.4/close_question'
// 评价问题
const EVALUATE_QUESTION = HOST + 'common-api/v1.4/evaluate_question'
// 标记问题
const SIGN_QUESTION = HOST + 'common-api/v1.4/sign_question'
// 是否是管理员
const IS_ADMIN = HOST + 'common-api/v1.4/qa/is_admin'

// 问答红包记录 v1.6
const ALLOWANCE_LOG_LIST = HOST + 'common-api/v1.6/allowance/log/list'
// 待领取红包 v1.6
const NEW_ALLOWANCES = HOST + 'common-api/v1.6/allowance/new_allowances'
// 查询我的红包账户 v1.6
const ALLOWANCES_INFO = HOST + 'common-api/v1.6/allowance/info'
// 领取红包 v1.6
const ALLOWANCES_ACCEPT = HOST + 'common-api/v1.6/allowance/accept'
// 获取问题会话id
const GET_DIALOG_ID = HOST + 'common-api/qaQuestion/getDialogId'

// 无忧伙伴相关
const CARE_FREE_PARENTER = {
  // 搜索用户
  SEARCH_USER: HOST + 'user-api/partnersQuestion/searchUser.json',
  // 创建问题
  CREAT_QUESTION: HOST + 'user-api/partnersQuestion/createQuestion.json',
  // 获取问题详情
  GET_QUES_DETAIL: HOST + 'user-api/partnersQuestion/getQuestionDetails',
  // 问题接单
  ACCEPT_ORDER: HOST + 'user-api/partnersQuestion/questionOrders.json',
  // 关闭问题
  CLOSE_QUES: HOST + 'user-api/partnersQuestion/closeQuestion.json'
}
// 获取证件类型集合
const CARD_TYEP_LIST = HOST + 'user-api/getCardTypeList.json'
// 获取实名信息
const UESR_REAL_NAME = HOST + 'user-api/getUserRealName.json'
// 保存实名信息
const SAVE_USER_REAL_NAME = HOST + 'user-api/saveUserRealName.json'
// 获取个人中心快捷分类
// const GET_MEMBER_CENTER_QUICK_LIST = NEWHOST + 'common-api/advertPosition/getPersonalCenterQuickClassifyList.json'
const GET_MEMBER_CENTER_QUICK_LIST = NEWHOST + 'common-api/advertPosition/getPersonalCenterQuickClassifyList.json'
// 获取定向跳转链接
const POST_DIRECT_JUMP_LINK = HOST + 'common-api/buriedPoint/jumpDetail.json'

// 仪表灯大全相关
const PANEL_LIGHTS = {
  // 获取所有分类及仪表灯信息
  GET_LIGHTS_DATA: HOST + 'common-api/categoryMeterLamp/list',
  // 搜搜仪表灯
  SEARCH_LIGHT: HOST + 'common-api/categoryMeterLamp/queryMeterLamp',
  // 获取仪表灯相对应的颜色集合信息
  LIGHT_COLOR_LIST: HOST + 'common-api/meterLampColor/listColorMeterLamp',
  // 根据仪表灯颜色查询对应的原因及解决方案
  GET_LIGHT_COLOR_INFO: HOST + 'common-api/meterLampColor/detailColorMeterLamp',
  // 分享页面获取详情
  GET_SHARE_DETAIL: HOST + 'common-api/meterLampColor/meterLampDetail'
}

// 问答关联资料
const GET_SOURCE_TITLE = HOST + 'common-api/qaQuestion/getSourceTitle.json'

// IQA逆向
const IQA_CREATE = HOST + 'search-api/iqa/create.json'
const IQA_QUERY_LIST = HOST + 'search-api/iqa/queryList.json'

/* 卡修宝典新直播 */

const KAIXUYUN_LIVE = {
  // 获取广告位
  getAdList: HOSTOLD + '/common-api/advert/getAdvertList',
  getClassifyList: HOST + 'video-api/getClassifyList.json',
  getLiveList: HOST + 'video-api/getLiveCourseList.json',
  getLiveDetail: HOST + 'video-api/liveCourse.json',
  liveMessage: HOST + 'video-api/liveMessage.json',
  applyCourse: HOST + 'video-api/applyLive.json'
}

/* 卡修宝典新个人中心相关信息 */
const MEMBER_STORE = {
  getIdentity: HOST + 'user-api/storeInfo/getIdentity.json', // 获取身份列表
  getStoreNature: HOST + 'user-api/storeInfo/getStoreNature.json', // 获取门店性质
  getProject: HOST + 'user-api/storeInfo/getProject.json', // 获取业务范围列表
  saveStoreInfo: HOST + 'user-api/storeInfo/saveStoreInfo.json', // 保存门店相关信息

  saveUser: HOST + 'page/userinfo/saveUser', // 保存用户信息
  uploadPic: HOST + 'blade-resource/oss/endpoint/put-file' // 保存用户信息
}

// 直播带货相关的商城
const MALL = {
  getDetail: HOST + '/mall-api/shopping/getGoodsDetails.json', // 获取商品详情
  quickPay: HOST + 'mall-api/order/fastPay.json', // 快捷支付
  queryPartsList: HOST + 'mall-api/shopping/getGoodsPartsList.json', // 获取配件信息
  getDefaultAddress: HOST + 'user-api/memberGift/getDefaultAddress.json', // 获取默认地址
  getliveGoods: HOST + 'video-api/LiveCommerce/listCommerce.json', // 获取直播带货商品列表
  checkPayStatus: HOST + 'mall-api/shopping/car/verificationOrderPayment.json', // 检查订单的支付状态
  detailCommerce: HOST + 'video-api/LiveCommerce/detailCommerce.json', // 获取直播带货福利详情
  payCommerce: HOST + 'video-api/LiveCommerce/payCommerce.json', // 直播带货专用支付接口
  receiveCoupon: HOST + 'video-api/LiveCommerce/receiveCoupon.json', // 领取优惠券

  getCouponCenterList: HOST + 'mall-api/coupon/getCouponCenterList.json', // 获取领券中心列表
  receiveCouponInTick: HOST + 'mall-api/coupon/receiveCoupon.json', // 领券中心-领取优惠券
  userCouponList: HOST + 'mall-api/coupon/getUserCouponList.json', // 用户优惠券列表

  orderList: HOST + 'mall-api/order/getOrderList.json', // 用户订单列表
  orderDetail: HOST + 'mall-api/order/getOrderDetails.json', // 订单详情
  cancleOrder: HOST + 'mall-api/order/orderCancel.json', // 取消订单
  orderConfirm: HOST + 'mall-api/order/orderConfirm.json', // 确认收货
  payOrder: HOST + 'mall-api/order/payOrder.json', // 订单支付
  queryLogistics: HOST + 'mall-api/order/queryLogistics.json' // 查询物流订单
}

const KXYCOIN = {
  getCoinCount: HOST + 'user-api/coin/getCoinCount.json', // 获取卡修币数量
  getCoinDetailedList: HOST + 'user-api/coin/getCoinDetailedList.json', // 获取收支明细
  getCoinRechargeList: HOST + 'user-api/coin/getCoinRechargeList.json', // 获取充值金额列表
  kaXiuCoinRecharge: HOST + 'mall-api/order/kaXiuCoinRecharge.json', // 卡修币充值
  getQuickClassifyList: NEWHOST + 'common-api/advertPosition/getQuickClassifyList.json' // 快捷分类
}

const GET_CONTENT_DETAIL = HOST + 'page/content/detail'
const GET_VIP_CARD_LIST = HOST + 'user-api/app/vipCard/list'
const ORDER_SUBMIT = HOST + 'user-api/app/order/submit'
const GET_RICHTEXT = HOST + 'common-api/advert/detail'

const GET_COLLECT_TYPE = HOST + 'search-api/dataOperate/getCollectionTypeList'
const GET_COLLECT_DATA = HOST + 'search-api/dataOperate/getCollectionDataList'

const GET_PINPAI_LIST = HOST + 'common-api/liufenxi/getPinpaiList'
const GET_XILIE_LIST = HOST + 'common-api/liufenxi/getXilieList'
const GET_XINGHAO_LIST = HOST + 'common-api/liufenxi/getXinghaoList'
const IMPORT_SHUJULIU = HOST + 'common-api/liufenxi/importShujuliu'
const FENXI_ONESTEP = HOST + 'common-api/liufenxi/fenxi-oneStep'
const GET_ECULIST = HOST + 'common-api/liufenxi/getEcuList'
const GET_DANWEI_LIST = HOST + 'common-api/liufenxi/getDanweiList'
const FENXI_TWOSTEP = HOST + 'common-api/liufenxi/fenxi-twoStep'

const GET_SCHEME = HOST + 'search-api/common/getScheme'

const SEARCH_ECUENCRYPTIONLIST = HOST + 'common-api/ecuEncryption/searchEcuEncryptionList'
const GET_PENYOUQIXINGCHENG = HOST + 'common-api/penyouqiXingcheng/getPenyouqiXingcheng'

const GET_PRODUCTMATCHINGLIST = HOST + 'user-api/app/productMatching/list'
const GET_PRODUCTMATCHING_SYSTEMLIST = HOST + 'user-api/app/productMatching/systemList'
const GET_PRODUCTMATCHING_MODELLIST = HOST + 'user-api/app/productMatching/modelList'
const GET_PRODUCTMATCHING_COLLECT = HOST + 'user-api/app/productMatching/collectModel'
const GET_PRODUCTMATCHING_COLLECTLIST = HOST + 'user-api/app/productMatching/getModelCollectList'

const GET_INFOMATIONLIST = HOST + 'user-api/app/information/firstList'
const FILEDOWNLOAD = HOST + 'user-api/app/document/download'

const GET_SEARCHVIPCOUNT = HOST + 'user-api/vipUser/searchVipCount'

export default {
  HOST,
  POST_CHOSEID,
  POST_APP_GETPDF,
  POST_GET_QUICKACTIVITYPAY,
  POST_GET_GETUSERPAYRECORD,
  HOSTOLD,
  POST_PARTS_INFO_GET_NEW,
  POST_PARTS_INFO_OPEN_SEARCH,
  POST_PARTS_INFO_DETAIL_OPEN_SEARCH,
  HOSTOLDWX,
  HOSTCOMMON,
  HOSTAPP,
  NEWHOST,
  HOSTRESOURCEPATH,
  POST_GET_GETKLLOPENIDBYCODE,
  POST_SHOPPING_CANCEL_ORDER,
  POST_COLLECT,
  POST_COLLECT_NEW,
  POST_SYS_LOG,
  POST_ADVERT_GET_SIGN_LIST,
  POST_ADVERT_POSITION,
  POST_ADVERT_POSITION_NEW,
  POST_WXAUTH_CHECK_SESSION,
  POST_WXAUTH_CHECK_SESSION_MPASS,
  POST_WXAUTH_GET_APPID,
  POST_USER_STATUS,
  POST_SYS_PRODUCT_HELP_ADN_FEEDBACK,
  POST_SYS_REPORT_LIST_TWO,
  POST_WXAUTH_VERIFY_CODE,
  POST_WXAUTH_CHECK_VERITY_CODE,
  POST_WXAUTH_USER_LOG,
  POST_WXAUTH_PHONE_NOTE,
  POST_WXAUTH_PAY,
  POST_WXAUTH_SLY_YOU,
  POST_MEMBER_PERSONAL_ACTIVITY_RESULT,
  POST_MEMBER_PERSONAL_ORDER_LIST_Phone,
  POST_SOSO_TEST_DATA,
  POST_MEMBER_PERSONAL_ACTIVITY_SIGN,
  POST_SOSO_TEST_DATA_NEW,
  POST_SOSO_TEST_DATA_OPEN_SEARCH,
  POST_SOSO_TEST_DATA_DETAIL_OPEN_SEARCH,
  POST_SOSO_CIRCUIT_DATA_SENDEMAIL,
  POST_SOSO_GASKET,
  POST_FALT_CODE_LIST,
  POST_SYS_PRODUCT_HELP_ADN_FEEDBACK_DETAIL,
  POST_PARTS_INFO_GET,
  POST_FALT_CODE_DETAIL,
  POST_PARTS_INFO_ENGINE,
  POST_PARTS_INFO_ENGINENO,
  POST_PARTS_INFO_ENGINE_RESULT,
  POST_SOSO_CIRCUIT_DATA_REMEMBER_EMAIL,
  POST_PARTS_OHK_INFO,
  POST_DATAUM_LOGO,
  POST_DATAUM_LIST,
  POST_LECTURE_ROOM_SHARE,
  POST_LECTURE_ROOM_CURRENT,
  POST_LECTURE_ROOM_DETAIL,
  POST_LECTURE_ROOM_COURSEWARE,
  POST_LECTURE_ROOM_CREATE_ORDER,
  POST_LECTURE_ROOM_CHECK_SHARE,
  POST_LECTURE_ROOM_SIGNIN,
  POST_LECTURE_ROOM_ATTEND,
  POST_LECTURE_ROOM_PAY_ITEMS,
  POST_LECTURE_ROOM_RED_PACK,
  POST_LECTURE_ROOM_OEPN_RED_PACK,
  POST_MEMBER_PERSONAL_INFO,
  POST_BASE_PERSONAL_INFO,
  POST_MEMBER_PERSONAL_SAVE,
  POST_MEMBER_USER_PHONE,
  POST_MEMBER_SENDMESSAGE,
  POST_SOSO_CIRCUIT_DATA_GETCATALOGUELIST,
  POST_SOSO_CIRCUIT_DATA_GETMATERIALLIST,
  POST_MEMBER_PERSONAL_SAVE_WXAUTH,
  POST_MEMBER_PERSONAL_ORDER_LIST,
  POST_MEMBER_PERSONAL_ORDER_DETAIL,
  POST_MEMBER_PERSONAL_ADDRESS_detail,
  POST_COMMON_GET_SEESION,
  POST_LECTURE_ROOM_COURSESTATU,
  POST_COMMON_WXSDK_CONFIG,
  POST_MEMBER_PERSONAL_ADDRESS,
  POST_MEMBER_PERSONAL_ADDRESS_ADD,
  POST_MEMBER_PERSONAL_ADDRESS_DEL,
  POST_MEMBER_PERSONAL_GET_GIFT,
  POST_MEMBER_PERSONAL_MSG_COUNT,
  POST_MEMBER_PERSONAL_CHECK_CODE,
  POST_MEMBER_PERSONAL_USE_COUNT,
  POST_MEMBER_PERSONAL_CANCEL_ORDER,
  POST_MEMBER_PERSONAL_GET_JS_PARAMETER,
  POST_MEMBER_PERSONAL_GET_JS_PARAMETER_NEW,
  POST_MEMBER_PERSONAL_GET_JS_LOTTERY,
  POST_MEMBER_SCOPE,
  POST_FALT_CODE_SOSO,
  POST_LECTURE_ROOM_ADVICE,
  POST_COLLECTION_SAVE,
  POST_COLLECTION_CANCEL,
  POST_URL_PARAMS_CURR_ORDER,
  LOCAL_STORAGE_AUTH_LOGIN_FLAG,
  POST_MEMBER_PERSONAL_COLLECT,
  POST_MEMBER_PERSONAL_COUPON,
  POST_MEMBER_PERSONAL_STORE,
  POST_MEMBER_PERSONAL_STORES,
  POST_MEMBER_PERSONAL_STORES_SAVE,
  POST_MEMBER_PERSONAL_STORES_BUSINESS,
  POST_MEMBER_PERSONAL_STORE_USER,
  POST_MEMBER_PERSONAL_STORE_SAVE,
  POST_MEMBER_PERSONAL_STORES_BUSINESS_SAVE,
  POST_MEMBER_PERSONAL_STORES_IMG,
  POST_MEMBER_PERSONAL_STORES_IMG_SAVE,
  POST_MEMBER_PERSONAL_STORES_IMG_SAVE_NEW,
  POST_MEMBER_PERSONAL_DAILY_SINGIN,
  POST_MEMBER_PERSONAL_EXCLUSIVE,
  POST_MEMBER_PERSONAL_DAILY_SINGIN_CHECK,
  POST_MEMBER_PERSONAL_STORE_ADDRESS,
  POST_MEMBER_PERSONAL_STORE_ADDRESS_SAVE,
  POST_MEMBER_PERSONAL_GET_MEDAL,
  POST_MEMBER_PERSONAL_GET_MEDAL_DETAIL,
  POST_MEMBER_PERSONAL_GET_MEDAL_REWARD,
  POST_MEMBER_PERSONAL_GET_REWARD_DETAIL,
  POST_MEMBER_PERSONAL_MEDAL_REWARD_WITHDRAW,
  POST_MEMBER_PERSONAL_GET_GATHER_PRAISE,
  POST_MEMBER_PERSONAL_MEDAL_GIVE_PRAISE,
  POST_MEMBER_PERSONAL_USER_PRAISE_LIST,
  POST_BROADCAST_ANCHOR_CHAT,
  POST_BROADCAST_COURSE_LIVING,
  POST_COURSE_GET_LIST,
  POST_COURSE_GET_DETAIL,
  POST_COURSE_GET_URL,
  POST_COURSE_GET_COURSE_GROUP_STATUS,
  POST_GET_COURSE_COMMENT,
  POST_ADD_COURSE_COMMENT,
  POST_COURSE_ORDER_PAY,
  POST_ORDER_SUBMIT,
  POST_ORDER_PAY,
  POST_ADD_COURSE_LOG,
  POST_COURSE_SPREAD_PURCHASE,
  POST_COURSE_SPREAD_CLASSIFY_LIST,
  POST_COURSE_SPREAD_CLASS_COURSE_LIST,
  POST_GET_SERIES_COURSE_URL,
  POST_ADD_COURSE_RECORD_NEW,
  POST_ADD_HOUR_RECORD_NEW,
  POST_COURSE_HOT_COURSE_LIST,
  POST_COURSE_GET_BROADCASE_LIST,
  POST_COURSE_LIVE_BROADCASE_LIST,
  POST_COURSE_CLASSIFY_LIST,
  POST_COURSE_ENJOY_COURSE_LIST,
  POST_COURSE_STUDY_RECORD_LIST,
  POST_COURSE_SEARCH_LIST,
  POST_COURSE_LIST_BY_CLASSIFY,
  POST_GET_BROADCAST_LIST,
  POST_GET_ENDED_BROADCAST_LIST,
  POST_SEARCH_BROADCAST,
  POST_GET_TICKET_BASIC_VALUE,
  POST_PAY_TICKET,
  POST_GET_TICKET_DETAIL,
  POST_BROADCAST_PAY,
  POST_BROADCAST_GET_TICKET,
  POST_CLASS_COURSE_GET_COURSE_DETAIL,
  POST_CLASS_COURSE_GET_COURSE_URL,
  POST_CLASS_COURSE_ADD_HOUR_LOG,
  POST_COURSE_GET_SECRET_URL,
  POST_COURSE_GET_LIVE_INFO,
  POST_COURSE_GET_LIVE_PLAYBACK,
  POST_COURSE_OPEN_REDPACKAGE,
  POST_COURSE_SEND_MESSAGE,
  POST_COURSE_SEND_MESSAGE_NEW,
  POST_COURSE_GET_GIFT_LIST,
  POST_COURSE_GIVE_REWARD,
  POST_COURSE_LIKE_COURSE,
  POST_COURSE_LIVE_PURCHASE,
  POST_COURSE_LIVE_INVITATION_LIST,
  POST_COURSE_LIVE_BENE_LIST,
  POST_COURSE_LIVE_WARE_LIST,
  POST_COURSE_LIVE_PRESENT_LIST,
  BALANCE,
  POST_COURSE_LIVE_BENE_DETAIL,
  POST_ADD_ACTIVITY_RESERVATION,
  POST_COMMUNITY_GET_MODUL,
  POST_COMMUNITY_GET_MODUL_LIST,
  POST_COMMUNITY_GET_ARTICLE_LIST,
  POST_COMMUNITY_GIVE_PRAISE,
  POST_COMMUNITY_USER_OPERATE,
  POST_COMMUNITY_GET_ARTICLE_DETAIL,
  POST_COMMUNITY_GET_ARTICLE_COMMENT,
  POST_COMMUNITY_ADD_ARTICLE_COMMENT,
  POST_COMMUNITY_GET_HOME_PAGE,
  POST_COMMUNITY_DELETE_ARTICLE,
  POST_COMMUNITY_UPDATE_STORE_LOCATION,
  POST_COMMUNITY_GET_USER_INFO,
  POST_COMMUNITY_UNREAD_MESSAGE_NUM,
  POST_COMMUNITY_GET_UNREAD_MESSAGE_LIST,
  POST_COMMUNITY_REMOVE_MESSAGE,
  POST_COMMUNITY_REPORT_TYPE_LIST,
  POST_COMMUNITY_REPORT_SUBMIT,
  POST_COMMUNITY_ARTICLE_AUDIT_LIST,
  POST_COMMUNITY_COMMENT_AUDIT_LIST,
  POST_COMMUNITY_ARTICLE_COMMENT_DETAIL,
  POST_COMMUNITY_REMOVE_ALL_MESSAGE,
  POST_COMMUNITY_GET_REWARD_TEXT_LIST,
  POST_COMMUNITY_COMMUNITY_REWARD_PAY,
  POST_COMMUNITY_DELETE_ARTICLE_COMMENT,
  POST_COMMUNITY_TASKCENTER_USER_SIGN,
  POST_COMMUNITY_TASKCENTER_INFO,
  POST_COMMUNITY_TASKCENTER_TASK_LIST,
  POST_COMMUNITY_SEND_POSTER,
  POST_COMMUNITY_NEW_TOPIC,
  POST_COMMUNITY_HOT_TOPIC,
  POST_COMMUNITY_CLICK_NEW_TOPIC,
  POST_COMMUNITY_ADD_SEARCH,
  POST_COMMUNITY_SEARCH_LIST,
  GET_COMMUNITY_ADD_SEARCH_LIST,
  POST_COMMUNITY_TASKCENTER_SIGN_DETAIL,
  POST_COMMUNITY_TASKCENTER_RECEIVE_STAR,
  POST_COMMUNITY_TASKCENTER_SIGN_NOTICE,
  POST_COMMUNITY_TASKCENTER_STARS_DETAIL,
  POST_COMMUNITY_TASKCENTER_RECORD_SHARE,
  POST_COMMUNITY_TASKCENTER_EXCHANGE_PRODUCT_LIST,
  POST_COMMUNITY_TASKCENTER_USER_EXCHANGE_PRODUCT,
  POST_COMMUNITY_TASKCENTER_BEANDETAIL_TYPELIST,
  POST_COMMUNITY_CASHQUESTION_CASH_ANSWER_HOME,
  POST_COMMUNITY_CASHQUESTION_REMIND,
  POST_COMMUNITY_CASHQUESTION_SUBMIT,
  POST_COMMUNITY_DAILY_CHECK_POSTER,
  POST_COMMUNITY_SEND_ARTICLE,
  POST_COMMUNITY_USER_SIGN_INFO,
  POST_COMMUNITY_ANNOUNCEMENT_LIST,
  POST_COMMUNITY_USER_FOLLOW_TOGGLE,
  POST_COMMUNITY_USER_FOLLOW_LIST,
  POST_CONSULT_TOKEN,
  POST_CONSULT_GET_USER_LIST,
  POST_CONSULT_STAFF_SEND_MESSAGE,
  POST_CONSULT_CUSTOM_TOKEN,
  POST_CONSULT_CUSTOM_SENT_MESSAGE,
  POST_CONSULT_CUSTOM_SEARCH_QUESTION,
  POST_CONSULT_CUSTOM_GET_CHAT_HISTORY,
  POST_GET_USET_REPAIR_CASE,
  POST_SUBMIT_USER_REPAIR_CASE,
  POST_GET_REBATE_LIST,
  POST_GET_REBATE_DETAIL,
  POST_REBATE_PRAISE,
  POST_ACTIVITY_SHARE_DETAILS,
  POST_ACTIVITY_SHARE_RECORD,
  POST_GET_ACTIVITY_DETAIL,
  POST_GET_SHARE_ACTIVITY,
  POST_ADD_USER_INVITATION,
  POST_ORDER_ACTIVITY_QUICK_PAY,
  POST_GET_MEMBER_GIFT_LIST,
  POST_GET_MEMBER_GIFT_LOG_LIST,
  POST_ACTIVITY_HOW_MUCH_SUBMMIT_ANSWER,
  POST_ACTIVITY_HOW_MUCH_GET_POSTER_INFO,
  POST_ACTIVITY_TURNPLATE_PRICE_LIST,
  POST_ACTIVITY_TURNPLATE_PRICE_RECORD_LIST,
  POST_ACTIVITY_TURNPLATE_USER_ALL_PRICE_LIST,
  POST_ACTIVITY_TURNPLATE_USER_DRAW_PRICE,
  POST_ACTIVITY_TURNPLATE_PRICE_LIST_LIVING,
  POST_ACTIVITY_TURNPLATE_PRICE_RECORD_LIST_LIVING,
  POST_ACTIVITY_TURNPLATE_USER_DRAW_PRICE_LIVING,
  POST_MEMBERSHIP_GET_REPAIR_LIST,
  POST_MEMBERSHIP_GET_TICKET_LIST,
  POST_MEMBERSHIP_GET_TASK_LIST,
  POST_MEMBERSHIP_GET_PLAYBACK_LIST,
  POST_MEMBERSHIP_GIFTS_GET_LIST,
  POST_MEMBERSHIP_GIFTS_GET_INFO,
  POST_MEMBERSHIP_GIFT_GET_DETAIL,
  POST_MEMBERSHIP_GIFT_ADD_TROLLEY,
  POST_MEMBERSHIP_GIFT_RECEIVE_LIST,
  POST_MEMBERSHIP_GIFT_TROLLEY_DETAIL,
  POST_MEMBERSHIP_GIFT_REMOVE_TROLLEY,
  POST_MEMBERSHIP_GIFT_SUBMIT_ORDER,
  POST_ADDRESS_GET_LIST,
  POST_ADDRESS_DEL_ITEM,
  POST_ADDRESS_GET_ITEM_DETAIL,
  POST_ADDRESS_SAVE_ITEM_DETAIL,
  POST_ADDRESS_SET_DEFAULT,
  POST_MEMBERSHIP_GET_RECOMMEND_INFO,
  POST_MEMBER_COMMUNITY_INFO,
  POST_MEMBER_GET_USER_INFO,
  POST_MEMBER_GET_USER_ASSETS,
  POST_DATA_LIB_GET_DIRECTORY_LIST,
  POST_DATA_LIB_GET_FIRST_UNITS_SELECTOR,
  POST_DATA_LIB_GET_SUBLEVEL_UNITS_SELECTOR,
  POST_DATA_LIB_GET_RESULT_DATA_LIST,
  POST_DATA_LIB_GET_TREE_SHARE_LIST,
  POST_DATA_LIB_GET_US_OR_DATA_LIST,
  POST_RECORD_POINT_GET_DETAIL,
  POST_RECORD_POINT_ADD_POINT,
  POST_ACTIVITY_SERVING_STATION_LIST,
  POST_GET_ADDRESS_BY_LATLNG,
  POST_CUSTOM_INTIMACY_DETAIL,
  POST_ABANDON_INTIMACY_PRICE,
  POST_MY_INTIMACY_CUSTOMER_LIST,
  POST_APPLY_FRIEND_PRICE,
  POST_APPLY_JUMP_QUEUE,
  POST_INTIMACY_VERIFY_LIST,
  POST_INTIMACY_VERIFY,

  POST_SKILLS_TEST,
  POST_ELECT_ARTICLE_LIST,
  POST_ELECT_ARTICLE_CATALOGUELIST,
  POST_ELECT_ARTICLE_SEARCHLIST,
  POST_SHOPPING_PRODUCT_GETTOPICINFO,
  POST_SHOPPING_INDEX_PRODUCT_LIST,
  POST_SHOPPING_INDEX_TIPS_TEXT,
  POST_SHOPPING_CART_LIST,
  POST_SHOPPING_CART_DEL,
  POST_SHOPPING_CART_DELS,
  POST_SHOPPING_CART_ADD,
  POST_SHOPPING_CART_UPDATE_NUM,
  POST_SHOPPING_CART_SUBMIT,
  POST_SHOPPING_PRODUCT_DETAIL,
  POST_SHOPPING_ORDER_DETAIL,
  POST_SHOPPING_ORDER_GET_IMG,
  POST_SHOPPING_ORDER_IMG_UPLOAD,
  POST_SHOPPING_ORDER_JS_PARAMETER,
  POST_SHOPPING_ORDER_UPDATE_ADDRESS,
  POST_SHOPPING_ORDER_ONLINE_STAG,
  POST_WXAUTH_ONLINE_STAGING,
  POST_MEMBER_PERSONAL_ORDER_LIST_Phone_To_Call,
  POST_SYS_REPORT_FOLDER,
  POST_SYS_REPORT_FOLDER_LIST,
  POST_SYS_REPORT_QUERY_PARAMS,
  POST_SYS_REPORT_LIST,
  POST_REMOTE_SUPPORT_STATUS,
  POST_REMOTE_SUPPORT_SUCCESS,
  POST_SHOPPING_PRODUCT_GETCATEGORYLIST,
  POST_CUSTOMER_GET_DRAWLIST,
  POST_CUSTOMER_GET_DRAWDETAIL,
  POST_CUSTOMER_EDIT_LUCKDRAW,
  POST_CUSTOMER_GET_PRIZELIST,
  POST_CUSTOMER_DEL_LUCKDRAW,
  POST_CUSTOMER_GET_STATION_INFO,
  POST_CUSTOMER_EDIT_STATION_INFO,
  POST_CUSTOMER_OPERATION_ARTICLE_LIST,
  POST_CUSTOMER_STATION_DYNAMIC_LIST,
  POST_CUSTOMER_INFO,
  POST_CUSTOMER_BOOK_KEEP_LIST,
  POST_CUSTOMER_UPDATE_BOOK_KEEP,
  POST_CUSTOMER_UPDATE_USERINFO,
  POST_CUSTOMER_INFORM_LUCKDRAW,
  POST_CUSTOMER_DEL_DYNAMIC_SINGLE,
  POST_DEALERMANAGE_GET_DEALERINFO,
  POST_DEALERMANAGE_GET_REBATEINFO,
  POST_DEALERMANAGE_REBATE_PUTFORWARD,
  POST_DEALERMANAGE_GET_MDSELIST,
  POST_DEALERMANAGE_SUBMIT_ORDER,
  POST_CUSTOMER_CREATEREWARD,
  POST_CUSTOMER_REWARD_INFO,
  POST_CUSTOMER_ACTIVITY_LIST,
  POST_CUSTOMER_ACTIVITY_DETAIL,
  POST_CUSTOMER_ADDUSERNOTICE,
  POST_CUSTOMER_ACTIVITY_DELETE,
  POST_CUSTOMER_ADD_ACTIVITY,
  POST_CUSTOMER_STATION_POSTER,
  POST_CUSTOMER_ACTIVITY_POSTER,
  POST_CUSTOMER_RECOMMEND_LIST,
  POST_CUSTOMER_TYPE_LIST,
  POST_FMS_BOTTOMAD,
  POST_WX_AUTH_LOGIN_VALIDATE,
  POST_WX_AUTH_LOGIN,
  POST_WX_SEND_MESSAGE,
  POST_COMMUNITY_USERINFO,

  POST_APP_SEND_CODE,
  POST_APP_LOGIN,
  POST_APP_LOGIN_OUT,
  POST_APP_NEW_LOGIN,
  POST_APP_MESSAGE_LIST,
  POST_SHOPPING_PRODUCT_GETTOPICLIST,
  POST_SHOPPING_PRODUCT_GETKEYWORDLIST,
  POST_SHOPPING_ORDER_QUICKPAY,
  POST_UNANSWER,
  POST_GET_GETChATLIST,
  POST_GET_GETDETAIL,
  POST_GET_DASHANG,
  POST_GET_SCORE,
  appGetQNToken,
  POST_GET_CLOSE,
  POST_QUESTION_HELP,
  POST_CHECK_REPLY,
  POST_GET_QUESTIONING,
  POST_CUS_BTN,
  POST_FALT_CODE_GETLABEL,
  POST_FALT_CODE_USERFEEDBACK,
  POST_MEMBER_GETVIPPACKAGELIST,
  POST_GET_GETKALULIAPPID,
  POST_SYS_PRODUC_PARISE,
  POST_SYS_PRODUC_GETDOCUMENTCOMMENTBYDOCUMENTId,
  POST_SYS_PRODUC_FEEDBACK_ADD,
  POST_SYS_PRODUC_FEEDBACK_ADDCOMMENT,
  POST_GET_IMGTEXT,
  POST_MEMBER_GIFT_ORDER_DETAIL,
  POST_MEMBER_APPLYGIFTORDER,
  POST_CUSTOMER,
  POST_DYNAMIC,
  POST_BOOKKEEPING,
  POST_GETUNREAD,
  POST_GETSHOPINFO,
  POST_GET_QUESTIONNAIRE,
  POST_SUB_QUESTIONS,
  POST_FALT_CODE_ADVANCEDSEARCH,
  GET_RECOMMEND_FMS_LIST,
  GET_SUBJECT_LIST,
  MEMBER_GIFT_CONFIRM,
  POST_MEMBER_RICH_TEXT,
  MEMBER_PAY_FOR_GIFT,
  GET_CRM_SALEINFO,
  CUT_PRICE,
  ADD_ONLINEQUE,
  MESSAGETAKE,
  MESSAGEBOX,
  POST_FALT_CODE_GETCHECKCONTENT,
  POST_FALT_CODE_GETCONTENT,
  ALIPAYAPP,

  TREMDETAIL,
  POST_EXAM_RESULT,
  POST_CURENT_LOCATION,

  POST_GRABUSERINFO,
  POST_QUERYDATALISTROW,
  POST_GRABUSER,

  POST_QUESTION_RESULT,
  POST_COMMUNITY_TASKCENTER_REDENVELOPE,
  POST_COMMUNITY_TASKCENTER_SUBMITVEHICLE,
  POST_GETPACKETPECORDLIST,
  POST_TASKCENTER_OPENREDPACKET,

  POST_USERINFOS,
  POST_JOINTEAM,
  POST_JOINRECORD,

  POST_CERTINFOS,
  POST_SELECTLIST,
  RENEW,

  REPAIR_ASKANSWER,
  POST_GETGIFT_ORDER_DETAIL,
  POST_AUDITGIFTORDER,

  POST_ORDER_BACK_DETAIL,
  POST_ORDER_BACK_UPDATE,

  POST_GET_FOLDER_ID,
  POST_ADD_SOSO_RECORD,
  POST_PRODUCT_RECORD_LIST,
  XNY_POST_PRODUCT_RECORD_LIST,
  POST_PRODUCT_HCL_MODULE_LIST,
  POST_CIRCUIT_DIRECTORY_LIST,
  POST_FIRST_VEHICLE_LIST,
  POST_SUB_VEHICLE_DATA_LIST,
  POST_SUB_VEHICLE_DATA_LIST_NEW,
  POST_SUB_VEHICLE_LIST_SORT,
  POST_SUB_LEVE_VEHICLE_LIST,
  POST_CURRENCY_DATA_LIST,
  POST_CURRENCY_DATA_LIST_NEW,

  HOME_PAGE,
  CARREPAIR,
  CORPUS,
  POST_GETENTRYCLASSLIST,
  POST_GETENCYLIST,
  POST_GET_ENCYDETAIL,

  POST_FAULT_DES_LIST,
  POST_FAULT_SEARCH,
  GET_FAULT_CODE_DETAIL,
  GET_FAULT_CODE_DETAIL_NEW,
  GET_FAULT_CODE_DETAIL_NEW2,
  XNY_GET_FAULT_CODE_DETAIL_NEW2,
  GET_UREA_LIST,
  GET_UREA_LIST_NEW,
  GET_UREA_LIST_NEW2,
  GET_TROUBLE_SHOOT_STEP,
  GET_TROUBLE_SHOOT_STEP_CONTENT,
  TROUBLESHOOT_STEP_CONTENT_BY_VEHIDIRID,
  XNY_TROUBLESHOOT_STEP_CONTENT_BY_VEHIDIRID,
  POST_DATA_SHARE,
  POST_FAULT_REASON_FEEDBACK,
  GET_WXTOP_GIIDEQUICK_CLASSIFYLIST,
  GET_HOME_PAGE_REMIND,

  POST_VEHICLE_MODULE_LIST,
  POST_VEHICLE_PART_AND_DATA_LIST,
  POST_SEARCHVHEIC_DIC_LIST,
  POST_JUDGE_POWER,
  POST_IS_REPLACE_TO_NEWSOSO,
  POST_FAULT_SEARCH_NEW,
  XNY_POST_FAULT_SEARCH_NEW,
  POST_SEARCH_KEYWORD_LIST,
  POST_SEARCH_KEYWORD_DETAIL,
  POST_SEARCH_PATH_LIST,
  POST_GET_CAR_TAB_INFO,

  GET_QUESTION_DRAFT,
  GET_QA_ASK_PARAMS,
  GET_REWARD_AMOUNT_LIST,
  QA_QUESTION_QUICK_PAY,
  SAVE_QUESTION,
  GET_QUESTION_DETAIL,
  GET_VOS_BY_QUESTION_NO,
  GET_QA_MY_QUESTION,
  GET_WX_OPEN_FLAG,
  GET_CURRENT_NOTICE_FLAG,
  CHANGE_OPEN_NOTICE_FLAG,
  GET_QA_MY_QUESTION_LIST,
  GET_SQUARE_NOTICE_PARAMS,
  SAVE_SQUARE_NOTICE,
  GET_QA_QUESTION_SQUARE_LIST,
  GET_UN_ACCEPT_QUESTION_DATA,
  USE_ACCELERATOR_CARD,
  USE_STAR_BEAN,
  GRAB_QA_QUESTION,
  QUERY_NOTICE_AND_QRCODE,
  QA_USERLOG_ADD,
  GET_NEW_QUESTION_FLAG,
  COMMUNITY_TASKCENTER_NEW,
  SEND_MESSAGE,
  GET_DIALOGUE_MESSAGE_LIST,
  ACCEPT_ANSWER,
  GET_HOME_PAGE_MSG_NUM,
  GET_QA_QUESTION_CARD_DATA,
  RECEIVE_CARD,
  CAN_NEW_QUESTION,
  QA_OUT_CALL,
  GET_RECOMMAND_INFOS,
  GET_LAST_QA_INFO,
  GET_QA_ASSISTANT_PAGE,
  LIST_QA_ASSISTANT_INFOS,
  CAN_GAIN_ACCELERATOR_CARD,
  GET_PARTS_COLL_MDSE_LIST,
  MDSPART_QUICK_PAY,
  GET_EQUIPMENT_COUPON_LIST,
  GET_EXCHANGE_EQUITY,
  READING_PROTOCOL_RECORD,
  TELEMARK_RECODE,
  ADD_SYS_REWARD,
  HIDE_SYS_QUESTION,
  GET_EXCHANGE_DDETAIL,
  GET_EQUITY_LIST,
  ADD_EQUITY_LOG,
  // 问答v1.3
  GET_QUICK_QA_INFOS,
  GET_QA_CONFIG,
  LIST_SYMPTOM,
  EDIT_QUESTION,
  UPDATE_QUESTION,
  LIST_DIALOG_INFO,
  LIST_MY_ANSWER,
  QUERY_DATA_LIST,
  GET_WX_WORK_APPID,
  GET_WX_WORK_SESSION,
  GET_WX_WORK_GGZJ_APPID,
  GET_WX_WORK_GGZJ_SESSION,
  CARE_FREE_PARENTER,
  CARD_TYEP_LIST,
  UESR_REAL_NAME,
  SAVE_USER_REAL_NAME,
  GET_MEMBER_CENTER_QUICK_LIST,
  // 问答1.4
  GET_SQUARE_NOTICE,
  QA_GRAB_NOTICE_SAVE,
  CANCEL_QUESTION,
  CLOSE_QUESTION,
  EVALUATE_QUESTION,
  SIGN_QUESTION,
  IS_ADMIN,
  IS_PICK_UPER,
  // 问答一键求助
  REWARD_AMOUNT_PAGE,
  TOP_CARD_STYLE,
  POST_DIRECT_JUMP_LINK,
  ALLOWANCE_LOG_LIST,
  NEW_ALLOWANCES,
  ALLOWANCES_INFO,
  ALLOWANCES_ACCEPT,
  PANEL_LIGHTS,
  GET_DIALOG_ID,
  GET_SOURCE_TITLE,
  COURSE4,
  IQA_CREATE,
  IQA_QUERY_LIST,
  // 定制购物车
  GET_CART_LIST,
  COUNT_POSTAGE,
  CREATE_ORDER,
  GET_SHOPPING_CART_COUPON,
  // 获取大搜新就接口配置
  GET_GRAY,
  KAIXUYUN_LIVE,
  POST_GET_STORE_INFO_NEW,
  MEMBER_STORE,
  MALL,
  KXYCOIN,
  getDataDetails,
  getLowerStrataDataList,
  getProductDirectoryList,
  searchDataList,
  getTypeList,
  getTypeSearchList,
  getSearchListByType,
  DICR_LIST,
  GET_CONTENT_DETAIL,
  GET_VIP_CARD_LIST,
  ORDER_SUBMIT,
  GET_RICHTEXT,
  GET_COLLECT_TYPE,
  GET_COLLECT_DATA,
  GET_PINPAI_LIST,
  GET_XILIE_LIST,
  GET_XINGHAO_LIST,
  IMPORT_SHUJULIU,
  FENXI_ONESTEP,
  GET_ECULIST,
  GET_DANWEI_LIST,
  FENXI_TWOSTEP,
  GET_SCHEME,
  SEARCH_ECUENCRYPTIONLIST,
  GET_PENYOUQIXINGCHENG,
  GET_PRODUCTMATCHINGLIST,
  GET_PRODUCTMATCHING_SYSTEMLIST,
  GET_PRODUCTMATCHING_MODELLIST,
  GET_PRODUCTMATCHING_COLLECT,
  GET_PRODUCTMATCHING_COLLECTLIST,
  GET_INFOMATIONLIST,
  FILEDOWNLOAD,
  GET_SEARCHVIPCOUNT
}
